// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:15:11.285Z
// Property: 5iftyone Tradan Heights (ID: 6737460151191752)
// Collections: 20 amenities, 6 floorplans (live), 100 photos, 72 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151191752",
  "property_external_id": "5026472",
  "property_zillow_url": "https://www.zillow.com/apartments/stillwater-ok/5iftyone-%40-tradan-heights/5XyKVR/",
  "property_apartments_url": "https://www.apartments.com/5iftyone-at-tradan-heights-stillwater-ok/p823sjr",
  "property_google_business_url": "https://www.google.com/maps/place/5iftyone+at+Tradan+Heights/data=!4m2!3m1!1s0x0:0xe14fbd20570dc3ef?sa=X&ved=2ahUKEwix7MzGwbySAxX0RjABHc1bOZQQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321121429",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "5iftyone-tradan-heights",
  "property_name": "5iftyone Tradan Heights",
  "property_website_url": "https://www.tradanheights.com/",
  "property_domain": "https://www.tradanheights.com/",
  "property_address": "920 S Murphy St",
  "property_full_address": "920 S Murphy St, Stillwater, OK 74074",
  "property_address_1": "920 S Murphy St",
  "property_address_2": null,
  "property_address_city": "Stillwater",
  "property_address_state": "OK",
  "property_address_zip_full": "74074-1586",
  "property_address_zip": "74074",
  "property_address_country": "US",
  "property_address_county": "Payne County",
  "property_neighborhood_address": "Oklahoma East Area",
  "property_address_latitude": "36.1117432",
  "property_address_longitude": "-97.1181045",
  "property_email": "tradanheights@rreafresidential.com",
  "property_phone": "(405) 624-1457",
  "property_call_tracking_phone": "405-925-0920",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to 5iftyone Tradan Heights in Stillwater, OK! Choose from spacious one and two-bedroom floor plans, complemented by exceptional amenities like gas grills, a 24-hour fitness center, sparkling pools, and a dog park. Find your new home today—browse our availability or schedule a tour to experience our community!",
  "property_long_description": "Welcome to 5iftyone Tradan Heights, your premier apartment community in the heart of Stillwater, OK! Discover a selection of thoughtfully designed floor plans, including spacious one and two-bedroom apartments that perfectly suit your lifestyle. Our community is tailored to elevate your living experience with a wide array of amenities designed for comfort and convenience.\n\nAt 5iftyone Tradan Heights, enjoy delightful outdoor gatherings with friends and family at our gas grill and fire pit areas, or unwind in our stylish clubroom. Stay active year-round in our state-of-the-art 24-hour fitness center, which includes free weights and ample space for workouts. For your peace of mind, our dedicated team offers 24-hour on-call maintenance and management, ensuring all your needs are met promptly.\n\nOur gated community provides safety and privacy, while amenities such as ample parking, covered parking options, car wash stations, and a dog park make daily living a breeze. With two sparkling pools, two playgrounds, a basketball court, and direct access to the lovely Vulcan Trail, there's always something to do right outside your doorstep.\n\nNeed to get work done? Utilize our fully equipped business center and conference room, or relax in our clubhouse. We also offer short-term leasing options for those with flexible living arrangements.\n\nFind your new home today at 5iftyone Tradan Heights! Browse our availability or schedule a tour to visit our vibrant community and discover the perfect blend of comfort and convenience tailored just for you!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019d076e-01c8-73f9-8715-71958dc22c29.webp",
  "property_featured_image_media": {
    "alt_text": "Community lounge area with plush seating, fireplace, and entertainment.",
    "public_id": "019d076e-01c8-73f9-8715-71958dc22c29",
    "storage_key": "property/6737460151191752/019d076e-01c8-73f9-8715-71958dc22c29.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "322",
  "property_year_built": "2012",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.8944099378882",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "One-Time Move-In Fees\nApplication Fee\n$65",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Up to 3 pets per apartment (maximum of 2 dogs).",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://5iftyonetradanheights.loftliving.com/login",
  "property_apply_now_url": "https://8921444.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-3e85-72de-b32d-617f1dd2f1f0.webp",
  "property_primary_logo_media": {
    "alt_text": "5iftyone at TRADAN HEIGHTS Apartment Homes logo",
    "public_id": "019e1e13-3e85-72de-b32d-617f1dd2f1f0",
    "storage_key": "property/6737460151191752/019e1e13-3e85-72de-b32d-617f1dd2f1f0.webp",
    "width": 2667,
    "height": 883
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-3e85-72de-b32d-617f1dd2f1f0.webp",
  "property_secondary_logo_media": {
    "alt_text": "5iftyone at TRADAN HEIGHTS Apartment Homes logo",
    "public_id": "019e1e13-3e85-72de-b32d-617f1dd2f1f0",
    "storage_key": "property/6737460151191752/019e1e13-3e85-72de-b32d-617f1dd2f1f0.webp",
    "width": 2667,
    "height": 883
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-3e85-72de-b32d-617f1dd2f1f0.webp",
  "property_mono_white_logo_media": {
    "alt_text": "5iftyone at TRADAN HEIGHTS Apartment Homes logo",
    "public_id": "019e1e13-3e85-72de-b32d-617f1dd2f1f0",
    "storage_key": "property/6737460151191752/019e1e13-3e85-72de-b32d-617f1dd2f1f0.webp",
    "width": 2667,
    "height": 883
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-3f10-77e7-94de-7eb319776a82.webp",
  "property_mono_black_logo_media": {
    "alt_text": "5fiftyone at TRADAN HEIGHTS Apartment Homes logo.",
    "public_id": "019e1e13-3f10-77e7-94de-7eb319776a82",
    "storage_key": "property/6737460151191752/019e1e13-3f10-77e7-94de-7eb319776a82.webp",
    "width": 835,
    "height": 299
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#d7591a",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": " - ",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": " - ",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "733 - 1311",
  "property_sqft_min": "733",
  "property_sqft_max": "1311",
  "property_price_range": "1325 - 1685",
  "property_price_min": "1325",
  "property_price_max": "1685",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/tradanheights/",
  "property_instagram_url": "https://www.instagram.com/FiftyOne_at_Tradan_Heights",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJB10VbuugsYcR78MNVyC9T-E",
  "property_youtube_url": "https://www.youtube.com/watch?t=142&v=nLes6souNuk",
  "property_yelp_url": "https://www.yelp.com/biz/tradan-heights-stillwater-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to 5iftyone Tradan Heights",
  "property_home_romance_title": "Experience Love at First Sight in Your Ideal Apartment Community",
  "property_home_amenities_blurb": "<p>Experience the best of laid-back and luxurious living at 5iftyone at Tradan Heights. Located in the crossways between Route 177 and State Highway 51, you're within reach of Oklahoma State University and all the delectable eateries, eclectic entertainment, and beautiful parks in Stillwater, Oklahoma. We offer spacious, pet-friendly, modern apartment homes with granite countertops, hardwood flooring, stainless-steel appliances, ceiling fans in bedrooms, and walk-in closets. Choose between well-designed one- and two-bedroom apartment homes. Satisfy your lifestyle and entertainment needs with <a href=\"/amenities/\">amenities</a> like sand and regular volleyball courts, fishing ponds, a fitness center, a resort-style pool, a community fire pit, resident events, and garages!</p>",
  "property_home_floorplans_blurb": "<p>See what delicious eateries, exciting entertainment, and gorgeous parks are around the <a href=\"/floor-plans/\">pet-friendly apartment</a> community of 5iftyone at Tradan Heights. There is plenty to discover around our Stillwater, OK, community, but our Neighborhood page offers a great starting point.</p>",
  "property_home_gallery_blurb": "Welcome to 5iftyone Tradan Heights in Stillwater, OK, where comfort meets convenience. Our thoughtfully designed one and two-bedroom floor plans boast modern amenities, including a fitness center, resort-style pool, and lush green spaces. Imagine unwinding by the cabana or enjoying a friendly game on our basketball court. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Discover the vibrant community surrounding 5iftyone Tradan Heights in Stillwater, OK! Explore our diverse one and two-bedroom floor plans and uncover local favorites and nearby points of interest. Don’t miss out—see what’s around our community and find your perfect home today!",
  "property_home_reviews_blurb": "Experience the charm of 5iftyone Tradan Heights in Stillwater, OK, where residents rave about the “friendly and professional” staff and a host of amenities, including a dog park and free Starbucks coffee. Join a vibrant community that turns apartment living into a delightful lifestyle—check out our resident testimonials today!",
  "property_neighborhood_blurb": "<p>See what delicious eateries, exciting entertainment, and gorgeous parks are around the <a href=\"/floor-plans/\">pet-friendly apartment</a> community of 5iftyone at Tradan Heights. There is plenty to discover around our Stillwater, OK, community, but our Neighborhood page offers a great starting point.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Upscale living wouldn't be complete without a full array of community amenities! Our pet-friendly <a href=\"/floor-plans/\">apartment</a> community in Stillwater, OK boasts access gates, a resort-style pool, state-of-the-art fitness center, volleyball courts, fishing ponds, fire pit, and curated resident events. Need an apartment with a garage? Ask about our available garages for rent. Our management team provides the professional and timely responses you are looking for. Connect with 5iftyone at Tradan Heights today.</p>",
  "property_applynow_blurb": "Discover your ideal living space at 5iftyone Tradan Heights in Stillwater, OK! Choose from spacious one and two-bedroom floor plans with top-notch amenities including a 24-hour fitness center, two sparkling pools, and a modern clubhouse. Experience convenience and luxury—find your new home and lease online today!",
  "property_contactus_blurb": "Discover your ideal home at 5iftyone Tradan Heights in Stillwater, OK. Explore our thoughtfully designed one and two-bedroom floor plans tailored to fit your lifestyle. Ready to learn more? Have questions? Contact our leasing team today for personalized assistance and start your journey to comfortable living!",
  "property_faqs_blurb": "Explore 5iftyone Tradan Heights in Stillwater, OK, where our thoughtfully designed one and two-bedroom floor plans meet your lifestyle needs. Have questions? Browse our FAQs page for answers about our vibrant community and discover why 5iftyone Tradan Heights is the perfect place to call home!",
  "property_floorplans_blurb": "<p>We want you to come home after a long day’s work to a comfortable and lavish abode. From spacious layouts, ceiling fans, and hardwood flooring to granite countertops, stainless steel appliances, walk-in closets, and personal outdoor space - 5iftyone at Tradan Heights is the <a href=\"/neighborhood/\">apartment community</a> you have been looking for in Stillwater, OK.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a <a href=\"/floor-plans/\">new apartment home</a> quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our community and apartments.</p>",
  "property_interactivemap_blurb": "Discover your perfect home at 5iftyone Tradan Heights in Stillwater, OK! Choose from stylish one and two-bedroom floor plans. Enjoy exceptional amenities like a 24-hour fitness center, gas grills, two sparkling pools, and a dog park. Use our interactive community map to explore available apartments and pricing today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "Discover your perfect home at 5iftyone Tradan Heights in Stillwater, OK! Choose from our stylish one and two-bedroom floor plans, tailored for comfort and convenience. Great friends make great neighbors—refer a friend to our vibrant community today and enjoy the benefits together! Explore your new lifestyle now!",
  "property_residentaccess_blurb": "Welcome to 5iftyone Tradan Heights in Stillwater, OK! Explore our versatile floor plans, including stylish one and two-bedroom options tailored to your lifestyle. Access your resident portal now to easily pay rent, schedule maintenance, and enjoy exclusive community updates. Experience convenience and comfort like never before!",
  "property_reviews_blurb": "At 5iftyone Tradan Heights, residents relish a vibrant community atmosphere filled with fantastic amenities like a dog park, resort-style pool, and free Starbucks coffee. One resident notes, \"The office staff is extremely nice and helpful,\" making it easy to call this inviting space home. Ready to join us?",
  "property_created_at": "1752257089331",
  "property_scheduletour_blurb": "Discover your perfect home at 5iftyone Tradan Heights in Stillwater, OK! Choose from spacious one and two-bedroom floor plans designed for comfort and style. Schedule a tour today and see what our residents love about living in our vibrant community! Don't miss out—experience the lifestyle you deserve!",
  "property_thankyou_blurb": "Thank you for your inquiry about 5iftyone Tradan Heights in Stillwater, OK! Explore our thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. A team member will reach out soon to help you discover your perfect home at our vibrant community. ",
  "property_virtualtours_blurb": "Discover your perfect home at 5iftyone Tradan Heights in Stillwater, OK! Explore our thoughtfully designed one and two-bedroom floor plans. Experience the comfort and style through our virtual tour. Take a virtual tour of our community and apartments for rent today—your ideal living space awaits!",
  "property_copyright": "2025 All Rights Reserved. 5iftyone Tradan Heights",
  "property_seo_title_home": "5iftyone Tradan Heights | Apartments in Stillwater, OK",
  "property_seo_description_home": "Discover modern living at 5iftyone Tradan Heights in Stillwater, OK! Explore diverse floor plans including one and two-bedroom apartments tailored for your lifestyle. Enjoy exceptional amenities like a 24-hour fitness center, two sparkling pools, dog park, and a clubhouse equipped for leisure and business. With covered parking, gas grills, and 24/7 on-call management, convenience and comfort await you. Don’t miss out on short-term leasing options in our gated community! Find your new home today at 5iftyone Tradan Heights!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Stillwater, OK",
  "property_seo_description_floorplans": "Discover your ideal living space at 5iftyone Tradan Heights in Stillwater, OK! Explore our diverse floor plans, featuring spacious one and two-bedroom apartments designed to suit your lifestyle. Browse our available apartment homes today and find the perfect fit for your needs. Don't miss out—your dream apartment awaits!",
  "property_seo_title_amenities": "Amenities | Stillwater, OK Apartments for Rent",
  "property_seo_description_amenities": "Discover your dream home at 5iftyone Tradan Heights in Stillwater, OK! Choose from spacious one and two-bedroom floor plans and enjoy exceptional amenities like gas grills, a 24-hour fitness center, and sparkling pools. Our gated community features a dog park, basketball court, and ample parking, ensuring convenience and comfort for every resident. Plus, benefit from on-call maintenance and management for peace of mind. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Stillwater, OK",
  "property_seo_description_gallery": "Discover your dream apartment at 5iftyone Tradan Heights in Stillwater, OK! Explore our stunning one and two-bedroom floor plans, complemented by exceptional amenities like two sparkling pools, a 24-hour fitness center, and a welcoming dog park. Enjoy social gatherings in the clubroom, grill up a feast at our gas BBQ area, or relax by the gas fire pit. Benefit from our gated community with ample covered parking, on-call maintenance, and a range of conveniences including a business center and car wash stations. Picture yourself living here—check out our photo gallery today!",
  "property_seo_title_virtualtours": "Virtual Tours | 5iftyone Tradan Heights Apartments",
  "property_seo_description_virtualtours": "Discover your new home at 5iftyone Tradan Heights in Stillwater, OK! Explore our range of floor plans including one and two-bedroom apartments designed for modern living. Take a virtual tour today and experience the vibrant community and amenities that await you. Find your perfect apartment for rent now!",
  "property_seo_title_interactivemap": "Interactive Map | 5iftyone Tradan Heights Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at 5iftyone Tradan Heights in Stillwater, OK! Our vibrant community offers spacious one- and two-bedroom floor plans with exceptional amenities, including two sparkling pools, a 24-hour fitness center, and a welcoming clubroom. Enjoy outdoor gatherings at our gas grill area or relax by the gas fire pit. With short-term leases available and a dedicated management team on call 24/7, convenience is just a click away. Use our interactive community map to explore available apartments, view pricing, and secure your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Stillwater, OK",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding 5iftyone Tradan Heights in Stillwater, OK! Explore our spacious one and two-bedroom floor plans while uncovering local favorites and nearby points of interest. See what's around our community and start your journey to a new home today!",
  "property_seo_title_contact": "Contact Us | 5iftyone Tradan Heights",
  "property_seo_description_contact": "Discover your perfect living space at 5iftyone Tradan Heights in Stillwater, OK! Explore our diverse floor plans, including cozy one-bedroom and spacious two-bedroom apartments. Have questions? Contact our leasing team today and let us help you find your ideal home!",
  "property_seo_title_faqs": "FAQs | Apartments in Stillwater, OK",
  "property_seo_description_faqs": "Discover your next home at 5iftyone Tradan Heights in Stillwater, OK! Explore our spacious one and two-bedroom floor plans complemented by luxurious amenities, including gas grills, a 24-hour fitness center, two sparkling pools, and a dog park. Enjoy the convenience of ample parking, a business center, and 24/7 on-call maintenance. Have questions? Browse our FAQs page for answers about our gated community and experience the lifestyle you deserve.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Stillwater, OK",
  "property_seo_description_reviews": "Discover the vibrant lifestyle at 5iftyone Tradan Heights in Stillwater, OK! Choose from spacious one and two-bedroom floor plans and enjoy exceptional amenities like a 24-hour fitness center, two sparkling pools, dog park, and gas grills. Experience peace of mind with 24/7 maintenance and a gated community. Read our resident reviews to see why our community stands out—join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Stillwater, OK",
  "property_seo_description_applynow": "Discover modern living at 5iftyone Tradan Heights in Stillwater, OK! Choose from spacious one and two-bedroom floor plans, and enjoy exceptional amenities like a 24-hour fitness center, two sparkling pools, a dog park, and ample parking. Our gated community features gas grills, a business center, and a welcoming clubroom for relaxation and gatherings. Experience 24/7 management and maintenance for peace of mind. Don’t miss out—find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | 5iftyone Tradan Heights",
  "property_seo_description_residentaccess": "\"Welcome to 5iftyone Tradan Heights in Stillwater, OK! Access your resident portal seamlessly to pay rent, schedule maintenance, and enjoy convenient living. Log in now for easy management of your home!\"",
  "property_seo_title_referafriend": "Refer A Friend | 5iftyone Tradan Heights",
  "property_seo_description_referafriend": "\"Great friends make great neighbors! At 5iftyone Tradan Heights in Stillwater, OK, you can share the joy of community living. Refer a friend today and enjoy exclusive rewards while building a thriving neighborhood together. Join us now!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | 5iftyone Tradan Heights",
  "property_seo_description_scheduletour": "Discover your new home at 5iftyone Tradan Heights in Stillwater, OK! Explore our modern amenities and vibrant community. Schedule a tour today and experience the lifestyle you've dreamed of!",
  "property_seo_title_privacy": "Privacy Policy | 5iftyone Tradan Heights",
  "property_seo_description_privacy": "Discover the commitment to your privacy at 5iftyone Tradan Heights in Stillwater, OK. Our Privacy Policy outlines how we protect your information and ensure a secure living experience. Click here to view our privacy policy and learn more about our dedication to your peace of mind!",
  "property_seo_title_accessibility": "Website Accessibility | 5iftyone Tradan Heights",
  "property_seo_description_accessibility": "\"Discover 5iftyone Tradan Heights in Stillwater, OK—where digital inclusion matters. Our Accessibility Statement showcases our commitment to creating an accessible online experience for all. Explore how we prioritize your needs and ensure a welcoming environment. Join us in valuing accessibility and community!\"",
  "property_seo_title_sitemap": "Sitemap | 5iftyone Tradan Heights",
  "property_seo_description_sitemap": "Explore 5iftyone Tradan Heights in Stillwater, OK! Discover our comprehensive sitemap for easy navigation of available floor plans, amenities, and community features. Find your perfect home today—view our sitemap now!",
  "property_seo_title_thankyou": "Thank You | 5iftyone Tradan Heights",
  "property_seo_description_thankyou": "Thank you for reaching out to 5iftyone Tradan Heights in Stillwater, OK! Your inquiry is important to us. A member of our team will be in touch shortly to assist you further. Discover your future home today!",
  "property_seo_title_pets": "Pet Policy | Apartments in Stillwater, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293558028",
  "amenities": [
    {
      "id": "ec_52f6cb160809e5176aa584f1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "external_id": "false",
      "title": "Access Gates",
      "amount": "false",
      "description": "Confirmed as listed under Community Amenities on the official site.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bb847e921ffb71c25ce2ebb2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Emergency Maintenance",
      "amount": "false",
      "description": "Confirmed as listed under Community Amenities on the official site.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a81cfe3b1cb3aedddea3c7cc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "external_id": "false",
      "title": "Community Fire Pit",
      "amount": "false",
      "description": "Confirmed as listed under Community Amenities on the official site.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ddb955adf7503cf625b25145",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "external_id": "false",
      "title": "Fishing Ponds",
      "amount": "false",
      "description": "Confirmed as listed under Community Amenities on the official site.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c0435843efaa39688deffeb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "external_id": "false",
      "title": "Garage Rental",
      "amount": "false",
      "description": "Confirmed as listed under Community Amenities on the official site.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_82a3d880f6efaf04d23f0300",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "external_id": "false",
      "title": "Online Payments Available",
      "amount": "false",
      "description": "Confirmed as listed under Community Amenities on the official site.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3c2b5c50cc557e776fd952a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "external_id": "false",
      "title": "Pet‑friendly",
      "amount": "false",
      "description": "Confirmed as listed under Community Amenities on the official site.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_62f409f09d524341e3bea1ca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "Confirmed as listed under Community Amenities on the official site.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_920bafdc4d6b4d4e61f90636",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "external_id": "false",
      "title": "Resort Style Pool",
      "amount": "false",
      "description": "Confirmed as listed under Community Amenities on the official site.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1810b8ed18d835f32febc623",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "external_id": "false",
      "title": "Sand Volleyball Court",
      "amount": "false",
      "description": "Confirmed as listed under Community Amenities on the official site.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cebbf677b80270e89bcb6c57",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "external_id": "false",
      "title": "State‑of‑the‑art Fitness Center",
      "amount": "false",
      "description": "Confirmed as listed under Community Amenities on the official site.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_936ae70d6df3239246e039d5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "external_id": "false",
      "title": "Volleyball Court",
      "amount": "false",
      "description": "Confirmed as listed under Community Amenities on the official site.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_61a2c440d5b637c640a2f1f5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans in Bedrooms",
      "amount": "false",
      "description": "Confirmed as listed under Apartment Features on the official site.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1be3dfdbd976e5cef2ac1fe2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "external_id": "false",
      "title": "Faux Wood Blinds",
      "amount": "false",
      "description": "Confirmed as listed under Apartment Features on the official site.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6df4d11a7149c0e0d9a0f4bc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "Confirmed as listed under Apartment Features on the official site.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e59442527847ad2ec7c2abb9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "external_id": "false",
      "title": "Hardwood Flooring",
      "amount": "false",
      "description": "Confirmed as listed under Apartment Features on the official site.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3df73efef7c30c3c7da46294",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "external_id": "false",
      "title": "Personal Outdoor Space",
      "amount": "false",
      "description": "Confirmed as listed under Apartment Features on the official site.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba7b3e50be3b1ab5e261e4b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "external_id": "false",
      "title": "Spacious Floor Plans",
      "amount": "false",
      "description": "Confirmed as listed under Apartment Features on the official site.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_48537b49f16ca52dd8ba86f5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "Confirmed as listed under Apartment Features on the official site.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_957dc6deef8d9dca3f99da59",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑in Closets",
      "amount": "false",
      "description": "Confirmed as listed under Apartment Features on the official site.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_abab8f90-e336-486e-a3cd-7c5097b4e2c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-bdb8-7383-bf93-9a4c7fc59bf1.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a covered cabana.",
        "public_id": "019e60ba-bdb8-7383-bf93-9a4c7fc59bf1",
        "storage_key": "property/6737460151191752/019e60ba-bdb8-7383-bf93-9a4c7fc59bf1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool, complete with comfortable lounge chairs and a shaded cabana, perfect for relaxing on sunny days.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a covered cabana.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5db70b28-5884-4d02-a8cd-7ec6abae2ca7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-da30-7582-af58-a6a710a911fe.webp",
      "image_media": {
        "alt_text": "Bedroom with a white upholstered bed, orange and white patterned bedding, and a window with curtains.",
        "public_id": "019e60ba-da30-7582-af58-a6a710a911fe",
        "storage_key": "property/6737460151191752/019e60ba-da30-7582-af58-a6a710a911fe.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Charming bedroom featuring a plush bed with vibrant bedding, complemented by elegant curtains and decorative wall art. A perfect retreat for relaxation.",
      "link": "",
      "alt_text": "Bedroom with a white upholstered bed, orange and white patterned bedding, and a window with curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cc25ba92-c625-432e-a018-1fd63a2a4ab6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-bd14-751f-adb4-5680dc23e204.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, and weight training equipment.",
        "public_id": "019e60ba-bd14-751f-adb4-5680dc23e204",
        "storage_key": "property/6737460151191752/019e60ba-bd14-751f-adb4-5680dc23e204.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines and weight training equipment for residents.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical machines, and weight training equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0265c818-66d0-4935-9753-b99131f896ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-b5fe-711e-b6f8-e99e79db1038.webp",
      "image_media": {
        "alt_text": "Interior lobby with high ceilings, exposed wooden beams, and stone accent walls.",
        "public_id": "019e60ba-b5fe-711e-b6f8-e99e79db1038",
        "storage_key": "property/6737460151191752/019e60ba-b5fe-711e-b6f8-e99e79db1038.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our spacious and inviting lobby, featuring a modern chandelier, artwork, and a sleek entertainment center.",
      "link": "",
      "alt_text": "Interior lobby with high ceilings, exposed wooden beams, and stone accent walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1b64d722-2a7f-42c8-b582-8ec76ff882f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-f8d1-773c-86d1-feb5118b5280.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and a commercial area with a Ford dealership and other businesses.",
        "public_id": "019e60ba-f8d1-773c-86d1-feb5118b5280",
        "storage_key": "property/6737460151191752/019e60ba-f8d1-773c-86d1-feb5118b5280.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "An aerial view showcases apartment buildings adjacent to a bustling commercial area featuring a Ford dealership, other retail stores, and extensive parking lots.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and a commercial area with a Ford dealership and other businesses.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c3cf66e8-b702-4406-ac99-42ed451801bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-fa3f-74f9-ba7a-e8e40eabddbd.webp",
      "image_media": {
        "alt_text": "Bill Knight Ford dealership exterior with new Ford trucks on display in the lot.",
        "public_id": "019e60ba-fa3f-74f9-ba7a-e8e40eabddbd",
        "storage_key": "property/6737460151191752/019e60ba-fa3f-74f9-ba7a-e8e40eabddbd.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Other",
      "description": "Visit Bill Knight Ford for a wide selection of new and pre-owned Ford trucks, cars, and SUVs. Our friendly staff is ready to assist you with sales, service, and financing.",
      "link": "",
      "alt_text": "Bill Knight Ford dealership exterior with new Ford trucks on display in the lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_df474ca4-f3ac-43bd-a7d9-2f8c4a0a5972",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-f29e-71ae-a5af-6f35dbe8350c.webp",
      "image_media": {
        "alt_text": "Aerial view of a neighborhood with houses, a pond with a fountain, and a pool area.",
        "public_id": "019e60ba-f29e-71ae-a5af-6f35dbe8350c",
        "storage_key": "property/6737460151191752/019e60ba-f29e-71ae-a5af-6f35dbe8350c.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Discover a beautiful neighborhood featuring charming homes, a serene pond with a fountain, and a resort-style pool area, perfect for relaxation and recreation.",
      "link": "",
      "alt_text": "Aerial view of a neighborhood with houses, a pond with a fountain, and a pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_10007ae3-bf1c-47c3-b84b-55b5ec42a7b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-ec37-763f-b7fd-4ffa1cd60d3c.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings, parking lot, and surrounding landscape.",
        "public_id": "019e60ba-ec37-763f-b7fd-4ffa1cd60d3c",
        "storage_key": "property/6737460151191752/019e60ba-ec37-763f-b7fd-4ffa1cd60d3c.webp",
        "width": 3072,
        "height": 1747
      },
      "title": "Community",
      "description": "Experience comfortable living in this expansive apartment complex, featuring modern architecture and ample green spaces.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings, parking lot, and surrounding landscape.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_afd8979c-b819-4780-91aa-12ba945c25ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-ed87-7077-8e95-cbc51aa5c512.webp",
      "image_media": {
        "alt_text": "Aerial view of a multi-story apartment building with a parking lot and surrounding residential neighborhood.",
        "public_id": "019e60ba-ed87-7077-8e95-cbc51aa5c512",
        "storage_key": "property/6737460151191752/019e60ba-ed87-7077-8e95-cbc51aa5c512.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Experience comfortable living in this modern apartment community, featuring ample parking and a prime location.",
      "link": "",
      "alt_text": "Aerial view of a multi-story apartment building with a parking lot and surrounding residential neighborhood.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_51a46376-88af-485d-bcd0-a68dda96612a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-ed77-76eb-b7ec-c478afcb7cb8.webp",
      "image_media": {
        "alt_text": "Aerial view of a residential neighborhood with a winding road and many trees.",
        "public_id": "019e60ba-ed77-76eb-b7ec-c478afcb7cb8",
        "storage_key": "property/6737460151191752/019e60ba-ed77-76eb-b7ec-c478afcb7cb8.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Discover this charming neighborhood with well-maintained homes and lush greenery, offering a peaceful and picturesque living environment.",
      "link": "",
      "alt_text": "Aerial view of a residential neighborhood with a winding road and many trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d3323125-7c37-4aba-bc9c-ce3d02a5f832",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-ec48-7103-bc6a-ad8a6f7ccaa3.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings, a lake, and a car dealership.",
        "public_id": "019e60ba-ec48-7103-bc6a-ad8a6f7ccaa3",
        "storage_key": "property/6737460151191752/019e60ba-ec48-7103-bc6a-ad8a6f7ccaa3.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "An aerial perspective showcasing the apartment community, adjacent lake, and surrounding commercial establishments, offering a glimpse of the neighborhood's amenities and accessibility.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings, a lake, and a car dealership.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_18d0c310-4f36-484e-8e5c-92df972c03e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-e557-719b-9a3d-24d729252ffa.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and surrounding neighborhood.",
        "public_id": "019e60ba-e557-719b-9a3d-24d729252ffa",
        "storage_key": "property/6737460151191752/019e60ba-e557-719b-9a3d-24d729252ffa.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing the apartment complex nestled within a suburban neighborhood, featuring well-maintained buildings, green spaces, and nearby amenities.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and surrounding neighborhood.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_63678624-7f99-4bb8-a023-cc4dd49cce24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-e9a4-74f9-a45c-2ed49f3a914e.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and surrounding landscape.",
        "public_id": "019e60ba-e9a4-74f9-a45c-2ed49f3a914e",
        "storage_key": "property/6737460151191752/019e60ba-e9a4-74f9-a45c-2ed49f3a914e.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Aerial view of a suburban neighborhood featuring apartment complexes, a road, and a lake.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and surrounding landscape.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_41ce1089-35e9-4eea-9481-2a3fea36592d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-df59-7295-a644-ef06d1c93be6.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with ponds and fountains in the foreground.",
        "public_id": "019e60ba-df59-7295-a644-ef06d1c93be6",
        "storage_key": "property/6737460151191752/019e60ba-df59-7295-a644-ef06d1c93be6.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Beautiful apartment complex featuring serene ponds with fountains, surrounded by lush greenery and modern architecture. Enjoy the peaceful ambiance of this community.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with ponds and fountains in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1ec09727-40ff-4759-8e52-cff789035297",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-db8f-71cc-b6bb-e3c2bf111b29.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and surrounding grounds.",
        "public_id": "019e60ba-db8f-71cc-b6bb-e3c2bf111b29",
        "storage_key": "property/6737460151191752/019e60ba-db8f-71cc-b6bb-e3c2bf111b29.webp",
        "width": 3072,
        "height": 1739
      },
      "title": "Community",
      "description": "An aerial perspective showcases the expansive layout of the apartment complex, featuring multiple residential buildings, parking areas, and manicured green spaces.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and surrounding grounds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a6834467-2ac8-4a08-abf6-249468da9bdf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-cfc1-74e6-a724-412617911a0e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019e60ba-cfc1-74e6-a724-412617911a0e",
        "storage_key": "property/6737460151191752/019e60ba-cfc1-74e6-a724-412617911a0e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and well-appointed bathroom featuring a granite countertop vanity, modern fixtures, a toilet, and a bathtub with a decorative shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_18cda96a-b69b-4aa7-913d-84d38fc8299f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-cb53-743f-9028-d8377252e76b.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property, showing apartment buildings and single-family homes.",
        "public_id": "019e60ba-cb53-743f-9028-d8377252e76b",
        "storage_key": "property/6737460151191752/019e60ba-cb53-743f-9028-d8377252e76b.webp",
        "width": 3072,
        "height": 1736
      },
      "title": "Community",
      "description": "An aerial view showcases the diverse housing options within the community, including modern apartment buildings and charming single-family homes.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property, showing apartment buildings and single-family homes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d3e8076c-fa98-42cb-84e1-389c59a5139c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-cb71-774e-8355-53b72b749102.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with pool and ponds.",
        "public_id": "019e60ba-cb71-774e-8355-53b72b749102",
        "storage_key": "property/6737460151191752/019e60ba-cb71-774e-8355-53b72b749102.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Expansive aerial view of a multifamily property showcasing its inviting swimming pool, serene ponds with fountains, and surrounding residential buildings.",
      "link": "",
      "alt_text": "Aerial view of apartment complex with pool and ponds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_68698432-4e4f-4b85-a8f9-888dbec3cf0d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-cd46-7335-ac9c-156a69ce067b.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and surrounding neighborhood",
        "public_id": "019e60ba-cd46-7335-ac9c-156a69ce067b",
        "storage_key": "property/6737460151191752/019e60ba-cd46-7335-ac9c-156a69ce067b.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Spacious apartment complex with modern architecture, ample parking, and well-maintained grounds, offering a comfortable living environment.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and surrounding neighborhood",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ec4e9db7-67dd-4e07-be32-c4a7fa32fafd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-c27d-731c-b224-d455bd6986f8.webp",
      "image_media": {
        "alt_text": "Balcony view of apartment buildings and parking lot.",
        "public_id": "019e60ba-c27d-731c-b224-d455bd6986f8",
        "storage_key": "property/6737460151191752/019e60ba-c27d-731c-b224-d455bd6986f8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the fresh air on your private balcony overlooking the property's amenities and beautifully maintained grounds.",
      "link": "",
      "alt_text": "Balcony view of apartment buildings and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6a543fef-3e7b-4d91-b4be-118759f54f36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-c874-76e9-ae3d-3498ee428f5d.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with single-family homes and apartment buildings.",
        "public_id": "019e60ba-c874-76e9-ae3d-3498ee428f5d",
        "storage_key": "property/6737460151191752/019e60ba-c874-76e9-ae3d-3498ee428f5d.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Experience the blend of comfortable single-family living and convenient apartment options in this charming community.",
      "link": "",
      "alt_text": "Aerial view of a suburban neighborhood with single-family homes and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_63828d4e-7995-4194-b194-e72641d975b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-a208-7193-a75c-822e92e17cf3.webp",
      "image_media": {
        "alt_text": "Spacious apartment living room with carpet, neutral walls, and large windows.",
        "public_id": "019e60ba-a208-7193-a75c-822e92e17cf3",
        "storage_key": "property/6737460151191752/019e60ba-a208-7193-a75c-822e92e17cf3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this inviting apartment living room, featuring plush carpeting and ample natural light from large windows.",
      "link": "",
      "alt_text": "Spacious apartment living room with carpet, neutral walls, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f4e13eea-da46-4e7a-aadf-dd6f40dd3f05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-a06c-73a8-a57b-6118803d91ab.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances including a microwave, oven, and refrigerator.",
        "public_id": "019e60ba-a06c-73a8-a57b-6118803d91ab",
        "storage_key": "property/6737460151191752/019e60ba-a06c-73a8-a57b-6118803d91ab.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed kitchen featuring sleek dark cabinetry, elegant granite countertops, and a full suite of stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances including a microwave, oven, and refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_802ced99-9825-4641-b7db-c42a2d1d8739",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-9d72-71e1-93e0-a8e0ec750855.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a clubhouse in the background.",
        "public_id": "019e60ba-9d72-71e1-93e0-a8e0ec750855",
        "storage_key": "property/6737460151191752/019e60ba-9d72-71e1-93e0-a8e0ec750855.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, complete with comfortable lounge seating and a beautifully appointed clubhouse.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a clubhouse in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bca533c8-ebe5-4e31-b7c1-bde54d7c5694",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-a0e4-74d7-bc81-61ea209b0d24.webp",
      "image_media": {
        "alt_text": "Empty living room and kitchen area with dark wood floors and neutral walls",
        "public_id": "019e60ba-a0e4-74d7-bc81-61ea209b0d24",
        "storage_key": "property/6737460151191752/019e60ba-a0e4-74d7-bc81-61ea209b0d24.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area featuring dark wood plank flooring, neutral wall colors, and a modern pendant light fixture.",
      "link": "",
      "alt_text": "Empty living room and kitchen area with dark wood floors and neutral walls",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_305b36c9-6c50-461e-b419-a11788531776",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-9ec3-73be-a1e1-ab4c71469c80.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances, and an island.",
        "public_id": "019e60ba-9ec3-73be-a1e1-ab4c71469c80",
        "storage_key": "property/6737460151191752/019e60ba-9ec3-73be-a1e1-ab4c71469c80.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring dark cabinetry, granite countertops, a full suite of stainless steel appliances, and an ample island for prep and dining.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances, and an island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7af57edb-10cd-4e0a-96ab-6c8f7f4d7e83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-98d0-76bd-a4d5-ec83409221db.webp",
      "image_media": {
        "alt_text": "Interior of a communal living area with a sofa, coffee table, and kitchen.",
        "public_id": "019e60ba-98d0-76bd-a4d5-ec83409221db",
        "storage_key": "property/6737460151191752/019e60ba-98d0-76bd-a4d5-ec83409221db.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed communal living spaces, featuring a modern kitchen and comfortable seating areas.",
      "link": "",
      "alt_text": "Interior of a communal living area with a sofa, coffee table, and kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6d270229-4a52-44cb-bfe5-26ec79e2b91e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-87ad-77b0-8d8e-88152d76fae4.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan, a walk-in closet, and an adjoining room.",
        "public_id": "019e60ba-87ad-77b0-8d8e-88152d76fae4",
        "storage_key": "property/6737460151191752/019e60ba-87ad-77b0-8d8e-88152d76fae4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, a walk-in closet, and access to an additional room, perfect for relaxation.",
      "link": "",
      "alt_text": "Bedroom with a ceiling fan, a walk-in closet, and an adjoining room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f3d70278-5dd2-4f23-bb7c-73c11896d621",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-87d9-7567-a9ab-4fbfd626f2cf.webp",
      "image_media": {
        "alt_text": "Living room with a large white sectional sofa, coffee table, TV, and accent wall.",
        "public_id": "019e60ba-87d9-7567-a9ab-4fbfd626f2cf",
        "storage_key": "property/6737460151191752/019e60ba-87d9-7567-a9ab-4fbfd626f2cf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sectional sofa, a rustic coffee table, a wall-mounted television, and stylish decor.",
      "link": "",
      "alt_text": "Living room with a large white sectional sofa, coffee table, TV, and accent wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e61a83fd-da2e-4d3b-8966-8a3b2d930bb8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-8857-7012-8807-5e8f6630bf56.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment with dark wood cabinets and granite countertops.",
        "public_id": "019e60ba-8857-7012-8807-5e8f6630bf56",
        "storage_key": "property/6737460151191752/019e60ba-8857-7012-8807-5e8f6630bf56.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room and modern kitchen featuring dark wood cabinets, granite countertops, and a breakfast bar, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area of an apartment with dark wood cabinets and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_79fdf1a5-e798-4867-98cb-abf81e7fbccf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-890e-719f-8d3e-d2a287cb9791.webp",
      "image_media": {
        "alt_text": "Outdoor bar with seating and television",
        "public_id": "019e60ba-890e-719f-8d3e-d2a287cb9791",
        "storage_key": "property/6737460151191752/019e60ba-890e-719f-8d3e-d2a287cb9791.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy drinks at the outdoor bar, complete with seating and a mounted television, perfect for social gatherings.",
      "link": "",
      "alt_text": "Outdoor bar with seating and television",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f15d4771-ce8d-4a87-a5ee-1d7c6b7a4ad7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-6e64-702e-9702-b336a087fb2a.webp",
      "image_media": {
        "alt_text": "Modern living room with sofa, coffee table, two armchairs, and kitchen in the background.",
        "public_id": "019e60ba-6e64-702e-9702-b336a087fb2a",
        "storage_key": "property/6737460151191752/019e60ba-6e64-702e-9702-b336a087fb2a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room featuring comfortable seating, a unique coffee table, and an open-concept kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living room with sofa, coffee table, two armchairs, and kitchen in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c1139807-002f-414b-abf8-ace09bfa7621",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-5eac-7330-a81f-4763aa2cb87b.webp",
      "image_media": {
        "alt_text": "Desk with a globe, decorative vases, and a large clock on the wall.",
        "public_id": "019e60ba-5eac-7330-a81f-4763aa2cb87b",
        "storage_key": "property/6737460151191752/019e60ba-5eac-7330-a81f-4763aa2cb87b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A stylish desk featuring a globe, decorative vases, and a prominent wall clock, adding a touch of sophistication to the living space.",
      "link": "",
      "alt_text": "Desk with a globe, decorative vases, and a large clock on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f044bc10-aeb2-4964-a014-b82426a367be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-6489-7132-8a97-8677ffef6331.webp",
      "image_media": {
        "alt_text": "Empty living room with beige carpet and two large windows with blinds.",
        "public_id": "019e60ba-6489-7132-8a97-8677ffef6331",
        "storage_key": "property/6737460151191752/019e60ba-6489-7132-8a97-8677ffef6331.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring plush beige carpeting and large windows that provide ample natural light.",
      "link": "",
      "alt_text": "Empty living room with beige carpet and two large windows with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_74075910-bf71-446d-8c6e-8f682152d258",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-5bfe-73ec-9570-53f62123d145.webp",
      "image_media": {
        "alt_text": "Modern living room with a large sectional sofa, leather accent chairs, and a wooden coffee table.",
        "public_id": "019e60ba-5bfe-73ec-9570-53f62123d145",
        "storage_key": "property/6737460151191752/019e60ba-5bfe-73ec-9570-53f62123d145.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished living area featuring a vaulted ceiling with exposed beams, a stone accent wall, and a mounted television.",
      "link": "",
      "alt_text": "Modern living room with a large sectional sofa, leather accent chairs, and a wooden coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8bf7316a-0886-4763-8e01-c1d64738c9b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-5bab-7491-8a56-5c6b6beb8a1a.webp",
      "image_media": {
        "alt_text": "Interior hallway with wood beams, stone accents, and modern art.",
        "public_id": "019e60ba-5bab-7491-8a56-5c6b6beb8a1a",
        "storage_key": "property/6737460151191752/019e60ba-5bab-7491-8a56-5c6b6beb8a1a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our beautiful interior hallway, featuring a spacious layout with exposed wood beams, elegant stone accents, and striking modern artwork.",
      "link": "",
      "alt_text": "Interior hallway with wood beams, stone accents, and modern art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2f679dc4-9688-4e95-ba3c-e2cf9eb9d882",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-5092-713f-a3c4-d741912a77b6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019e60ba-5092-713f-a3c4-d741912a77b6",
        "storage_key": "property/6737460151191752/019e60ba-5092-713f-a3c4-d741912a77b6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring dark wood cabinetry, sleek granite countertops, stainless steel appliances, and a large island with a sink. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d53d0aeb-4370-46fb-a6c1-9ea6f7904af8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-3ed2-705d-a072-b9ec30d1ce1e.webp",
      "image_media": {
        "alt_text": "Row of elliptical machines and treadmills in a fitness center.",
        "public_id": "019e60ba-3ed2-705d-a072-b9ec30d1ce1e",
        "storage_key": "property/6737460151191752/019e60ba-3ed2-705d-a072-b9ec30d1ce1e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our well-equipped fitness center, featuring a variety of cardio machines for your workout.",
      "link": "",
      "alt_text": "Row of elliptical machines and treadmills in a fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5d0d7fb6-d0f6-4df1-8a5d-c9c767bb1a26",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-4b85-71ea-9e74-42e5e1b7d6e1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances, and a refrigerator.",
        "public_id": "019e60ba-4b85-71ea-9e74-42e5e1b7d6e1",
        "storage_key": "property/6737460151191752/019e60ba-4b85-71ea-9e74-42e5e1b7d6e1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover the fully-equipped kitchen in our apartments, featuring dark cabinetry, granite countertops, and stainless steel appliances for a sleek and functional cooking space.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances, and a refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c041c353-2841-4c37-980a-e2d45c8baa2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-3c80-76ab-964b-92a49910d9dd.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a large pantry.",
        "public_id": "019e60ba-3c80-76ab-964b-92a49910d9dd",
        "storage_key": "property/6737460151191752/019e60ba-3c80-76ab-964b-92a49910d9dd.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring dark wood cabinetry, sleek granite countertops, and stainless steel appliances. Plenty of storage and counter space for all your culinary needs.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a large pantry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fdcda83d-a6ec-49bb-ae1c-7e2b80a580ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-5819-73a8-b240-627c310cd1c1.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with island and dark cabinetry.",
        "public_id": "019e60ba-5819-73a8-b240-627c310cd1c1",
        "storage_key": "property/6737460151191752/019e60ba-5819-73a8-b240-627c310cd1c1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area seamlessly flowing into a modern kitchen featuring dark wood cabinets, granite countertops, and a curved island.",
      "link": "",
      "alt_text": "Living room and kitchen area with island and dark cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5a5c7dc8-1078-4706-9661-2abc47bdf01e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-3b55-741a-91ec-0d292711b4af.webp",
      "image_media": {
        "alt_text": "Modern living room with a couch, coffee table, and accent chairs, open to a kitchen.",
        "public_id": "019e60ba-3b55-741a-91ec-0d292711b4af",
        "storage_key": "property/6737460151191752/019e60ba-3b55-741a-91ec-0d292711b4af.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with comfortable seating, perfect for relaxing or entertaining. The open-concept design seamlessly connects to a modern kitchen.",
      "link": "",
      "alt_text": "Modern living room with a couch, coffee table, and accent chairs, open to a kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a7af5da7-d060-460d-a3cb-ee1fa0966360",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-3f7f-737a-ba68-a69733cb2182.webp",
      "image_media": {
        "alt_text": "Shuffleboard table in a common area with sports-themed decor.",
        "public_id": "019e60ba-3f7f-737a-ba68-a69733cb2182",
        "storage_key": "property/6737460151191752/019e60ba-3f7f-737a-ba68-a69733cb2182.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a game of shuffleboard in our resident lounge, featuring sports-themed artwork and comfortable seating.",
      "link": "",
      "alt_text": "Shuffleboard table in a common area with sports-themed decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4f14136a-efe0-416c-b9af-90f4af7d2f57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-2fbd-7368-b939-149d861b199a.webp",
      "image_media": {
        "alt_text": "Resort-style outdoor swimming pool with lounge chairs and a clubhouse.",
        "public_id": "019e60ba-2fbd-7368-b939-149d861b199a",
        "storage_key": "property/6737460151191752/019e60ba-2fbd-7368-b939-149d861b199a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing and soaking up the sun. The adjacent clubhouse offers a comfortable space for residents to gather.",
      "link": "",
      "alt_text": "Resort-style outdoor swimming pool with lounge chairs and a clubhouse.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e811d6c8-eef8-4c5c-9a7c-1588c5006b70",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-2fbe-723e-b20f-d9a90093609b.webp",
      "image_media": {
        "alt_text": "Community lounge area with fireplace, TV, shuffleboard, and seating.",
        "public_id": "019e60ba-2fbe-723e-b20f-d9a90093609b",
        "storage_key": "property/6737460151191752/019e60ba-2fbe-723e-b20f-d9a90093609b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in the community lounge, featuring a cozy fireplace, entertainment center, shuffleboard table, and comfortable seating areas for socializing.",
      "link": "",
      "alt_text": "Community lounge area with fireplace, TV, shuffleboard, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ec8a11ea-6632-4c10-b221-33a01fe6d2c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-247b-71ee-8c6f-586d1027d9ee.webp",
      "image_media": {
        "alt_text": "Bedroom with queen bed, orange and white patterned comforter, and sheer curtains.",
        "public_id": "019e60ba-247b-71ee-8c6f-586d1027d9ee",
        "storage_key": "property/6737460151191752/019e60ba-247b-71ee-8c6f-586d1027d9ee.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A beautifully appointed bedroom featuring a queen-sized bed with vibrant orange and white patterned bedding. Sheer curtains with orange accents frame the window, allowing natural light to fill the space. Stylish decor enhances the room's appeal.",
      "link": "",
      "alt_text": "Bedroom with queen bed, orange and white patterned comforter, and sheer curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6fe5fd1d-ede7-4b0a-8b63-59e92c4158d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-1acd-7058-b9dd-321bafebde6c.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, orange and white patterned bedding, and modern wall art.",
        "public_id": "019e60ba-1acd-7058-b9dd-321bafebde6c",
        "storage_key": "property/6737460151191752/019e60ba-1acd-7058-b9dd-321bafebde6c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax in this stylish bedroom featuring a comfortable queen-size bed with vibrant patterned bedding and contemporary wall decor. An adjoining open doorway reveals the kitchen area.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, orange and white patterned bedding, and modern wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ad41a7f0-20c7-4ea1-a4f6-afca7367bffe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-1795-746e-be14-b4e182103b35.webp",
      "image_media": {
        "alt_text": "Modern living room with leather chairs, sofa, coffee table, and open-plan kitchen in the background.",
        "public_id": "019e60ba-1795-746e-be14-b4e182103b35",
        "storage_key": "property/6737460151191752/019e60ba-1795-746e-be14-b4e182103b35.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax in style in this spacious living area featuring plush seating, a rustic coffee table, and a seamless transition to the modern kitchen.",
      "link": "",
      "alt_text": "Modern living room with leather chairs, sofa, coffee table, and open-plan kitchen in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_18771841-4c71-4337-b85c-a085108fb063",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-085c-74f0-b4c0-acad6d6b23dc.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and covered cabana area.",
        "public_id": "019e60ba-085c-74f0-b4c0-acad6d6b23dc",
        "storage_key": "property/6737460151191752/019e60ba-085c-74f0-b4c0-acad6d6b23dc.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and a shaded cabana for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and covered cabana area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1ee4bb6b-3104-4c7c-a5b9-8e52b01da59f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60ba-13ec-736f-9f5e-a4493d2456fa.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, granite island with seating, and stainless steel appliances.",
        "public_id": "019e60ba-13ec-736f-9f5e-a4493d2456fa",
        "storage_key": "property/6737460151191752/019e60ba-13ec-736f-9f5e-a4493d2456fa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring dark cabinetry, a spacious granite countertop island with bar stools, and modern stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, granite island with seating, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_321d3a61-3d2c-4f43-9683-1ee335a8b5b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-d95d-7059-bbc3-75ff19c65003.webp",
      "image_media": {
        "alt_text": "Community lounge with a coffee bar, seating areas, and a large Connect 4 game.",
        "public_id": "019e60b9-d95d-7059-bbc3-75ff19c65003",
        "storage_key": "property/6737460151191752/019e60b9-d95d-7059-bbc3-75ff19c65003.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and socialize in our community lounge, complete with a coffee bar, comfortable seating, and fun activities like Connect 4.",
      "link": "",
      "alt_text": "Community lounge with a coffee bar, seating areas, and a large Connect 4 game.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cb39d24c-36e8-4a7f-90af-5962a41c3e53",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-ce1c-729a-bbf8-68df47e55982.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, weight machines, medicine balls, and benches.",
        "public_id": "019e60b9-ce1c-729a-bbf8-68df47e55982",
        "storage_key": "property/6737460151191752/019e60b9-ce1c-729a-bbf8-68df47e55982.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with modern cardio machines, free weights, and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with treadmills, weight machines, medicine balls, and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_90ddbe76-4b9e-47b4-bc55-f5271d11d633",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-c946-7375-babc-fd1d6cac2fe1.webp",
      "image_media": {
        "alt_text": "Clubhouse exterior with stone and wood accents, surrounded by landscaping.",
        "public_id": "019e60b9-c946-7375-babc-fd1d6cac2fe1",
        "storage_key": "property/6737460151191752/019e60b9-c946-7375-babc-fd1d6cac2fe1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome to the clubhouse, the heart of our community. Enjoy our amenities and resident services.",
      "link": "",
      "alt_text": "Clubhouse exterior with stone and wood accents, surrounded by landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c4df79b3-f974-4fff-a936-1512dbe368a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-cd87-778e-bef1-9a64f9d7dc1e.webp",
      "image_media": {
        "alt_text": "Lounge area with leather sofas, a fireplace, and decorative artwork.",
        "public_id": "019e60b9-cd87-778e-bef1-9a64f9d7dc1e",
        "storage_key": "property/6737460151191752/019e60b9-cd87-778e-bef1-9a64f9d7dc1e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, featuring comfortable seating and a modern fireplace.",
      "link": "",
      "alt_text": "Lounge area with leather sofas, a fireplace, and decorative artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c720f466-827e-4b76-b74b-357195993e4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-b9d2-74a8-89e6-7bd1a0704a7c.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, orange and white patterned comforter, and decorative wall art.",
        "public_id": "019e60b9-b9d2-74a8-89e6-7bd1a0704a7c",
        "storage_key": "property/6737460151191752/019e60b9-b9d2-74a8-89e6-7bd1a0704a7c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Charming bedroom featuring a queen-size bed with vibrant orange and white bedding, complemented by elegant wall decor and a plush carpet.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, orange and white patterned comforter, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_505e6be8-bc3f-4b50-900d-8e43d9756278",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-c66c-73b2-baff-2f738929dd5c.webp",
      "image_media": {
        "alt_text": "Shuffleboard table in a common area with themed artwork.",
        "public_id": "019e60b9-c66c-73b2-baff-2f738929dd5c",
        "storage_key": "property/6737460151191752/019e60b9-c66c-73b2-baff-2f738929dd5c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a game of shuffleboard in our community's game room, complete with engaging artwork.",
      "link": "",
      "alt_text": "Shuffleboard table in a common area with themed artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7e4318fa-91c2-4af5-a5f7-544c909a57a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-a6aa-7538-a02b-d6cc32860018.webp",
      "image_media": {
        "alt_text": "Apartment complex with a putting green and lush green lawn.",
        "public_id": "019e60b9-a6aa-7538-a02b-d6cc32860018",
        "storage_key": "property/6737460151191752/019e60b9-a6aa-7538-a02b-d6cc32860018.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation with our community's putting green, surrounded by beautifully maintained grounds and modern apartment buildings.",
      "link": "",
      "alt_text": "Apartment complex with a putting green and lush green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d0a8624a-2e56-48e5-8264-d4f44b792d09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-a7dd-70ce-9085-34a7b15b5e3b.webp",
      "image_media": {
        "alt_text": "Kitchen with granite island, dark cabinets, stainless steel appliances, and seating for two.",
        "public_id": "019e60b9-a7dd-70ce-9085-34a7b15b5e3b",
        "storage_key": "property/6737460151191752/019e60b9-a7dd-70ce-9085-34a7b15b5e3b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this modern apartment kitchen, featuring a spacious granite island, ample cabinet storage, and sleek stainless steel appliances.",
      "link": "",
      "alt_text": "Kitchen with granite island, dark cabinets, stainless steel appliances, and seating for two.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_adcfbb4d-eabf-4c7c-8b66-504456da948f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-a81d-77f8-a9d0-2b44e869d403.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and bathtub with a decorative shower curtain.",
        "public_id": "019e60b9-a81d-77f8-a9d0-2b44e869d403",
        "storage_key": "property/6737460151191752/019e60b9-a81d-77f8-a9d0-2b44e869d403.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom, featuring a spacious vanity with granite countertops, a modern toilet, and a bathtub with a stylish shower curtain. Perfect for your daily relaxation.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, and bathtub with a decorative shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c5510550-d79b-4844-b6a7-38c2a65d5f9e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-a397-76d6-a3ff-6b3775c73a3a.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, weight bench, and dumbbells.",
        "public_id": "019e60b9-a397-76d6-a3ff-6b3775c73a3a",
        "storage_key": "property/6737460151191752/019e60b9-a397-76d6-a3ff-6b3775c73a3a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, free weights, and strength training machines for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, weight bench, and dumbbells.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5635cc3b-2586-4b8b-b059-c3d59cba58dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-9335-7404-924c-04d2786f06ca.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, orange and white bedding, and a mirrored nightstand.",
        "public_id": "019e60b9-9335-7404-924c-04d2786f06ca",
        "storage_key": "property/6737460151191752/019e60b9-9335-7404-924c-04d2786f06ca.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-size bed with vibrant orange and white patterned bedding. Accompanied by a sleek mirrored nightstand.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, orange and white bedding, and a mirrored nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e319031f-dc64-4c0e-8486-3875ae0750f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-79cf-7404-8343-d6b8b6f64498.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with white wire shelving",
        "public_id": "019e60b9-79cf-7404-8343-d6b8b6f64498",
        "storage_key": "property/6737460151191752/019e60b9-79cf-7404-8343-d6b8b6f64498.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample white wire shelving for all your storage needs.",
      "link": "",
      "alt_text": "Empty walk-in closet with white wire shelving",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a95f15ba-f93a-4cbc-8c81-b7960ada23c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-7321-726b-be50-6f4b00e8cdb0.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertop, sink, mirror, and decorative flowers.",
        "public_id": "019e60b9-7321-726b-be50-6f4b00e8cdb0",
        "storage_key": "property/6737460151191752/019e60b9-7321-726b-be50-6f4b00e8cdb0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a stylish vanity with a granite countertop, a modern sink, and a large mirror. Decorative floral arrangements add a touch of elegance.",
      "link": "",
      "alt_text": "Bathroom vanity with granite countertop, sink, mirror, and decorative flowers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cb027777-b491-4e31-80fb-0829ce6381a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-54e5-737d-9d33-6ce4c5bb3e76.webp",
      "image_media": {
        "alt_text": "Bedroom with a white headboard, orange and white patterned comforter and pillows, and abstract wall art.",
        "public_id": "019e60b9-54e5-737d-9d33-6ce4c5bb3e76",
        "storage_key": "property/6737460151191752/019e60b9-54e5-737d-9d33-6ce4c5bb3e76.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a plush white headboard, vibrant orange and white patterned bedding, and modern abstract art for a stylish living space.",
      "link": "",
      "alt_text": "Bedroom with a white headboard, orange and white patterned comforter and pillows, and abstract wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3c4cf923-b8f6-4483-afd0-e4cea864b7b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-50de-7468-8808-17dcd17f778f.webp",
      "image_media": {
        "alt_text": "Community room with tables and chairs, large windows overlooking outdoor area.",
        "public_id": "019e60b9-50de-7468-8808-17dcd17f778f",
        "storage_key": "property/6737460151191752/019e60b9-50de-7468-8808-17dcd17f778f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in this comfortable community room, featuring ample seating and large windows with scenic views.",
      "link": "",
      "alt_text": "Community room with tables and chairs, large windows overlooking outdoor area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_55cd56c9-4362-4652-8694-36129678896b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-4b43-7088-bfc5-956af3756e8e.webp",
      "image_media": {
        "alt_text": "Apartment buildings with a dog park in the foreground, featuring agility equipment.",
        "public_id": "019e60b9-4b43-7088-bfc5-956af3756e8e",
        "storage_key": "property/6737460151191752/019e60b9-4b43-7088-bfc5-956af3756e8e.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, complete with agility equipment for your furry friends to play and explore.",
      "link": "",
      "alt_text": "Apartment buildings with a dog park in the foreground, featuring agility equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2035e746-3067-4bcd-a9f5-d93e6c19aa1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-3d4d-743d-bef3-dd4959894502.webp",
      "image_media": {
        "alt_text": "Fenced-in dog park with agility equipment and benches, with apartment buildings in the background.",
        "public_id": "019e60b9-3d4d-743d-bef3-dd4959894502",
        "storage_key": "property/6737460151191752/019e60b9-3d4d-743d-bef3-dd4959894502.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with agility equipment and waste stations, providing a safe and fun space for your furry friends to play and exercise.",
      "link": "",
      "alt_text": "Fenced-in dog park with agility equipment and benches, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cb7456f4-e072-4dce-aefa-696c0457883e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-3e87-74e8-b432-f5a454958e4f.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with parking lot and two cars.",
        "public_id": "019e60b9-3e87-74e8-b432-f5a454958e4f",
        "storage_key": "property/6737460151191752/019e60b9-3e87-74e8-b432-f5a454958e4f.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring multiple levels, balconies, and a well-maintained parking lot.",
      "link": "",
      "alt_text": "Apartment building exterior with parking lot and two cars.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_65f1c442-b2c6-4bc5-a742-e46f6ce715a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-3d2b-70fd-97f7-fc131d8e85f5.webp",
      "image_media": {
        "alt_text": "Spacious walk-in closet with built-in shelving.",
        "public_id": "019e60b9-3d2b-70fd-97f7-fc131d8e85f5",
        "storage_key": "property/6737460151191752/019e60b9-3d2b-70fd-97f7-fc131d8e85f5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy ample storage space in this generous walk-in closet, featuring convenient built-in shelving for all your organizational needs.",
      "link": "",
      "alt_text": "Spacious walk-in closet with built-in shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b2eba3e3-7322-4420-a9f5-4d08f3b5af87",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-3237-73cc-acb9-fedf28d78bee.webp",
      "image_media": {
        "alt_text": "Entrance to 50fiftyone community with a pond and landscaping.",
        "public_id": "019e60b9-3237-73cc-acb9-fedf28d78bee",
        "storage_key": "property/6737460151191752/019e60b9-3237-73cc-acb9-fedf28d78bee.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Welcome to the 50fiftyone community, featuring a serene pond and beautifully landscaped grounds.",
      "link": "",
      "alt_text": "Entrance to 50fiftyone community with a pond and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_39080a59-75d5-4d51-8173-12f068dfe0a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-3c3b-74ee-a65b-007e845b4b1c.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower-tub combo.",
        "public_id": "019e60b9-3c3b-74ee-a65b-007e845b4b1c",
        "storage_key": "property/6737460151191752/019e60b9-3c3b-74ee-a65b-007e845b4b1c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This bathroom features a granite-top vanity with a modern sink, a toilet, and a shower-tub combination with a decorative curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and shower-tub combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1ad76967-bdf4-40c5-8872-1ec1f7e134ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-3208-76d9-afcc-b8989d71b2ef.webp",
      "image_media": {
        "alt_text": "Basketball court with apartment buildings in the background.",
        "public_id": "019e60b9-3208-76d9-afcc-b8989d71b2ef",
        "storage_key": "property/6737460151191752/019e60b9-3208-76d9-afcc-b8989d71b2ef.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Enjoy a game of basketball on our outdoor court, surrounded by beautiful landscaping and apartment buildings.",
      "link": "",
      "alt_text": "Basketball court with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_813b82a5-41b1-48a7-ac48-5325e831426e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-2c9b-747d-a5c5-803dea5f30b4.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with manicured lawn and trees.",
        "public_id": "019e60b9-2c9b-747d-a5c5-803dea5f30b4",
        "storage_key": "property/6737460151191752/019e60b9-2c9b-747d-a5c5-803dea5f30b4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautiful apartment building exterior with lush green lawns and mature trees, offering a welcoming facade.",
      "link": "",
      "alt_text": "Exterior view of apartment building with manicured lawn and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d50d857d-1156-488e-89e3-ad61e06b2436",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-1fa9-733b-8d3a-1b2f7ae2cc21.webp",
      "image_media": {
        "alt_text": "Clubhouse exterior with stone accents and double doors.",
        "public_id": "019e60b9-1fa9-733b-8d3a-1b2f7ae2cc21",
        "storage_key": "property/6737460151191752/019e60b9-1fa9-733b-8d3a-1b2f7ae2cc21.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming clubhouse exterior featuring stone accents, manicured landscaping, and double doors, offering a welcoming entrance.",
      "link": "",
      "alt_text": "Clubhouse exterior with stone accents and double doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8b5828fc-c8c2-4ceb-9f03-11ae93d52d0a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b9-1505-732c-acbb-0807ea8e2c13.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with garages and parking lot.",
        "public_id": "019e60b9-1505-732c-acbb-0807ea8e2c13",
        "storage_key": "property/6737460151191752/019e60b9-1505-732c-acbb-0807ea8e2c13.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of modern apartment buildings featuring individual garages and a spacious parking lot.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with garages and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1303f9fe-aea7-4279-8ddc-64f72b1e3885",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-ed6d-7171-8032-ed7c7a69337e.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with ponds and manicured lawns.",
        "public_id": "019e60b8-ed6d-7171-8032-ed7c7a69337e",
        "storage_key": "property/6737460151191752/019e60b8-ed6d-7171-8032-ed7c7a69337e.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Experience beautiful living with scenic ponds and lush green spaces at our community.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with ponds and manicured lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_744b3e4c-8b7f-4648-99cb-3ab78219667a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-fee7-72c8-b020-c132a8e15c0e.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with brick and tan siding, balconies, and manicured lawn.",
        "public_id": "019e60b8-fee7-72c8-b020-c132a8e15c0e",
        "storage_key": "property/6737460151191752/019e60b8-fee7-72c8-b020-c132a8e15c0e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover comfortable living in this modern apartment building, featuring attractive brick and siding exterior, private balconies, and lush green spaces.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with brick and tan siding, balconies, and manicured lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5e8f97ff-1807-48ad-87b3-caf151d55ec8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-ea3c-720e-a0f1-843068f52bb7.webp",
      "image_media": {
        "alt_text": "Apartment buildings with a pond, fountain, and disc golf basket.",
        "public_id": "019e60b8-ea3c-720e-a0f1-843068f52bb7",
        "storage_key": "property/6737460151191752/019e60b8-ea3c-720e-a0f1-843068f52bb7.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Experience resort-style living with beautiful landscaping, a tranquil pond, and recreational amenities like a disc golf course.",
      "link": "",
      "alt_text": "Apartment buildings with a pond, fountain, and disc golf basket.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f26fcab0-eeff-40c5-9241-2a3fb456e56d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-fe14-73cc-83e8-960fe727122a.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns, picnic area, and putting green.",
        "public_id": "019e60b8-fe14-73cc-83e8-960fe727122a",
        "storage_key": "property/6737460151191752/019e60b8-fe14-73cc-83e8-960fe727122a.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Discover comfortable living with spacious grounds and amenities, including a picnic area and putting green, perfect for relaxation and recreation.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with lush green lawns, picnic area, and putting green.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fd4d8d33-fe6d-425d-b868-189438c715f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-f68d-775e-b997-634003f81d6a.webp",
      "image_media": {
        "alt_text": "Beach volleyball court with apartment buildings in the background.",
        "public_id": "019e60b8-f68d-775e-b997-634003f81d6a",
        "storage_key": "property/6737460151191752/019e60b8-f68d-775e-b997-634003f81d6a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a friendly game of beach volleyball at our community's sand court, surrounded by beautiful apartment buildings.",
      "link": "",
      "alt_text": "Beach volleyball court with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8659a7e1-e9b6-4079-9e72-82291d042663",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-e727-764c-9ae2-35f0b63f4960.webp",
      "image_media": {
        "alt_text": "Fitness center with dumbbells, weight machines, treadmills, and elliptical trainers.",
        "public_id": "019e60b8-e727-764c-9ae2-35f0b63f4960",
        "storage_key": "property/6737460151191752/019e60b8-e727-764c-9ae2-35f0b63f4960.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a full range of cardio and weight training equipment.",
      "link": "",
      "alt_text": "Fitness center with dumbbells, weight machines, treadmills, and elliptical trainers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8bde2b95-842f-4948-a4fa-bd6cad6086c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-f08a-71ef-a7ba-8ec3f64d9b74.webp",
      "image_media": {
        "alt_text": "5fiftyone monument sign with stone base and landscaping.",
        "public_id": "019e60b8-f08a-71ef-a7ba-8ec3f64d9b74",
        "storage_key": "property/6737460151191752/019e60b8-f08a-71ef-a7ba-8ec3f64d9b74.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to 5fiftyone, where comfort and convenience meet. This monument sign marks the entrance to our beautiful community.",
      "link": "",
      "alt_text": "5fiftyone monument sign with stone base and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_55c6d34b-70ed-43ff-a716-2f66cb3dcdb4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-e14f-710d-b8fd-0977fa7f2961.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, weight bench, and medicine balls, overlooking a pool.",
        "public_id": "019e60b8-e14f-710d-b8fd-0977fa7f2961",
        "storage_key": "property/6737460151191752/019e60b8-e14f-710d-b8fd-0977fa7f2961.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our well-equipped fitness center. Featuring treadmills, weight training equipment, and stunning views of the community pool.",
      "link": "",
      "alt_text": "Gym with treadmills, weight bench, and medicine balls, overlooking a pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e103ce1b-a9c1-4070-bb0f-c3459e13d5fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-e797-7312-8b4b-6467c1eb0589.webp",
      "image_media": {
        "alt_text": "Well-equipped gym with treadmills, weight machines, and free weights.",
        "public_id": "019e60b8-e797-7312-8b4b-6467c1eb0589",
        "storage_key": "property/6737460151191752/019e60b8-e797-7312-8b4b-6467c1eb0589.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and reach your fitness goals in our state-of-the-art fitness center, featuring a variety of cardio machines and weight training equipment.",
      "link": "",
      "alt_text": "Well-equipped gym with treadmills, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3721da3c-ad70-4c25-9ac2-12e8ec0a85f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-e0db-7155-a8b0-edc080997ed2.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and clubhouse with lounge chairs and umbrellas.",
        "public_id": "019e60b8-e0db-7155-a8b0-edc080997ed2",
        "storage_key": "property/6737460151191752/019e60b8-e0db-7155-a8b0-edc080997ed2.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning swimming pool, surrounded by lush landscaping and comfortable seating. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and clubhouse with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_79a97f96-1bb0-40d9-8a7d-e716bb81cab2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-c7dd-72a0-9ed6-a979c3b7f37b.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with picnic area and BBQ grill.",
        "public_id": "019e60b8-c7dd-72a0-9ed6-a979c3b7f37b",
        "storage_key": "property/6737460151191752/019e60b8-c7dd-72a0-9ed6-a979c3b7f37b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and relaxation at our community picnic area, complete with a grill and comfortable seating.",
      "link": "",
      "alt_text": "Apartment building exterior with picnic area and BBQ grill.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f1a2aa17-e185-422b-a8e4-7454d7b76897",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-c3fc-756d-a177-ca5a3c626d35.webp",
      "image_media": {
        "alt_text": "Signage for 5fiftyone apartments with a brick and stone monument.",
        "public_id": "019e60b8-c3fc-756d-a177-ca5a3c626d35",
        "storage_key": "property/6737460151191752/019e60b8-c3fc-756d-a177-ca5a3c626d35.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Welcome to 5fiftyone apartments, a beautiful community with modern amenities and a convenient location. View our floor plans and schedule a tour today!",
      "link": "",
      "alt_text": "Signage for 5fiftyone apartments with a brick and stone monument.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_11728f8f-f593-4c6a-b977-f2cf0fbfd85a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-c1e2-730c-bc82-d7ea0ac545e6.webp",
      "image_media": {
        "alt_text": "View of the apartment complex buildings, pool area, and surrounding landscape.",
        "public_id": "019e60b8-c1e2-730c-bc82-d7ea0ac545e6",
        "storage_key": "property/6737460151191752/019e60b8-c1e2-730c-bc82-d7ea0ac545e6.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Welcome to our beautiful apartment community, featuring resort-style amenities and lush green spaces. Enjoy the sparkling pool, elegant clubhouse, and serene pond.",
      "link": "",
      "alt_text": "View of the apartment complex buildings, pool area, and surrounding landscape.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_817b5745-153c-4700-91b5-f0e89033d1d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-bc4c-734b-8857-87445bc1751a.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with a swimming pool, clubhouse, and pond.",
        "public_id": "019e60b8-bc4c-734b-8857-87445bc1751a",
        "storage_key": "property/6737460151191752/019e60b8-bc4c-734b-8857-87445bc1751a.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Experience resort-style living with our stunning swimming pool, clubhouse, and serene pond. A perfect blend of comfort and convenience.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property with a swimming pool, clubhouse, and pond.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5690a977-69c8-4f5f-83aa-e1527d225b11",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-aa98-7538-8b73-3f755cd47401.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment building with parking lot and cars.",
        "public_id": "019e60b8-aa98-7538-8b73-3f755cd47401",
        "storage_key": "property/6737460151191752/019e60b8-aa98-7538-8b73-3f755cd47401.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring brick and wood accents, with balconies and a well-maintained parking area. Offers comfortable living spaces in a vibrant community.",
      "link": "",
      "alt_text": "Exterior view of the apartment building with parking lot and cars.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aa58d822-fd89-4663-8ea9-a81d561bcac9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-85d4-7090-9a85-2fb4c0748976.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with resort-style pool, pond, and surrounding landscaping.",
        "public_id": "019e60b8-85d4-7090-9a85-2fb4c0748976",
        "storage_key": "property/6737460151191752/019e60b8-85d4-7090-9a85-2fb4c0748976.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Discover your new home at our apartment community, featuring a sparkling pool, serene pond, and lush green spaces for a relaxing lifestyle.",
      "link": "",
      "alt_text": "Aerial view of apartment complex with resort-style pool, pond, and surrounding landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ea9ce170-5602-4df7-8677-79108e4f094f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-8d37-74f5-8618-fdeb53ca07a7.webp",
      "image_media": {
        "alt_text": "Bar area with seating in apartment community lounge",
        "public_id": "019e60b8-8d37-74f5-8618-fdeb53ca07a7",
        "storage_key": "property/6737460151191752/019e60b8-8d37-74f5-8618-fdeb53ca07a7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stylish bar area with seating in the apartment community lounge, featuring a TV and modern decor.",
      "link": "",
      "alt_text": "Bar area with seating in apartment community lounge",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fe0c54b2-7c89-44a5-ab94-0b7a6ff118c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-8567-778b-b06a-adf33259a140.webp",
      "image_media": {
        "alt_text": "A grassy dog park area with two benches and a wooden fence.",
        "public_id": "019e60b8-8567-778b-b06a-adf33259a140",
        "storage_key": "property/6737460151191752/019e60b8-8567-778b-b06a-adf33259a140.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our community dog park, a safe and enclosed space for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "A grassy dog park area with two benches and a wooden fence.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f178e152-9ffb-47f3-9a2f-028c450701a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-85d3-750d-afca-1f909c74e38a.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with a fenced-in dog park area.",
        "public_id": "019e60b8-85d3-750d-afca-1f909c74e38a",
        "storage_key": "property/6737460151191752/019e60b8-85d3-750d-afca-1f909c74e38a.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Spacious apartment building exterior featuring a well-maintained dog park with lush green turf and agility equipment. Enjoy the convenience of on-site amenities for your furry friends.",
      "link": "",
      "alt_text": "Exterior view of apartment building with a fenced-in dog park area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d0fa6e3c-d94b-4aa7-a058-e031e8e2230f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-83b1-75d6-af96-44b5aa1fe5b9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and clubhouse at a multifamily property.",
        "public_id": "019e60b8-83b1-75d6-af96-44b5aa1fe5b9",
        "storage_key": "property/6737460151191752/019e60b8-83b1-75d6-af96-44b5aa1fe5b9.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, or relax by the water. The beautifully landscaped grounds and modern clubhouse offer the perfect amenities for your lifestyle.",
      "link": "",
      "alt_text": "Outdoor swimming pool and clubhouse at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d62b577b-b385-4e79-a87b-52e7f5d9a9f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-8424-744e-b20b-6bb3a10ee7dd.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and a clubhouse in the background.",
        "public_id": "019e60b8-8424-744e-b20b-6bb3a10ee7dd",
        "storage_key": "property/6737460151191752/019e60b8-8424-744e-b20b-6bb3a10ee7dd.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the resort-style swimming pool, complete with comfortable lounge chairs and a modern clubhouse.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs and a clubhouse in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6b031e7a-634c-486d-bcc9-4cbd7a6a496e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-7fb7-739a-8704-3f7f0a92e3bc.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with garages.",
        "public_id": "019e60b8-7fb7-739a-8704-3f7f0a92e3bc",
        "storage_key": "property/6737460151191752/019e60b8-7fb7-739a-8704-3f7f0a92e3bc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of apartment building showcasing the attached garages and architecture.",
      "link": "",
      "alt_text": "Exterior view of apartment building with garages.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7a83d23d-bb01-4da5-a471-e5b89dcabd3f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-8463-70bd-8b6a-d2e3ef60d233.webp",
      "image_media": {
        "alt_text": "Exterior view of townhome-style apartments with garages on the ground floor.",
        "public_id": "019e60b8-8463-70bd-8b6a-d2e3ef60d233",
        "storage_key": "property/6737460151191752/019e60b8-8463-70bd-8b6a-d2e3ef60d233.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Townhome-style apartments featuring attached garages on the ground level, offering convenient parking and storage.",
      "link": "",
      "alt_text": "Exterior view of townhome-style apartments with garages on the ground floor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_37ceee6a-a837-4efe-ac36-5e587a5e19e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-81bc-7260-8c29-0bc1924d16c9.webp",
      "image_media": {
        "alt_text": "Entrance to a multifamily property with a pond and stone monument signs.",
        "public_id": "019e60b8-81bc-7260-8c29-0bc1924d16c9",
        "storage_key": "property/6737460151191752/019e60b8-81bc-7260-8c29-0bc1924d16c9.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Welcome to a beautiful multifamily property featuring a serene pond, lush green landscaping, and elegant monument signage at the entrance.",
      "link": "",
      "alt_text": "Entrance to a multifamily property with a pond and stone monument signs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c9468f2b-cb25-4f0e-953b-ddc500762315",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e60b8-8126-7028-bf77-a21d76bdb432.webp",
      "image_media": {
        "alt_text": "Luxurious resident lounge with leather sofas, a fireplace, TV, and shuffleboard.",
        "public_id": "019e60b8-8126-7028-bf77-a21d76bdb432",
        "storage_key": "property/6737460151191752/019e60b8-8126-7028-bf77-a21d76bdb432.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our elegant resident lounge, featuring comfortable seating, a modern fireplace, a large television, and recreational shuffleboard.",
      "link": "",
      "alt_text": "Luxurious resident lounge with leather sofas, a fireplace, TV, and shuffleboard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_9e3cb41a-ef9e-46ef-ae0e-274acb27ced4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Hideaway Pizza",
      "poi_type": "Restaurants",
      "poi_address": "230 S Knoblock St, Stillwater, OK 74074, USA",
      "poi_short_description": "Local chain featuring build-your-own pies, a variety of Italian fare & a kids' menu.",
      "poi_long_description": "Local chain featuring build-your-own pies, a variety of Italian fare & a kids' menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e12-f26d-70fe-b7ff-4c053c2c4300.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-f26d-70fe-b7ff-4c053c2c4300",
        "storage_key": "property/6737460151191752/019e1e12-f26d-70fe-b7ff-4c053c2c4300.webp",
        "width": 1170,
        "height": 645
      },
      "poi_business_url": "https://www.thehideaway.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10499539512989782497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hideaway-pizza",
      "poi_latitude": "36.1194808",
      "poi_longitude": "-97.0657903",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-372-4777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-25ea-735b-81fd-332aa927e4ed",
        "storage_key": "property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUSRYUUcKsYcR4RHv4I7btZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_26f95a55-3ec4-4bc5-bd91-e07fbb3e0385",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "The Garage Burgers & Beer",
      "poi_type": "Restaurants",
      "poi_address": "520 W Elm Ave, Stillwater, OK 74074, USA",
      "poi_short_description": "Neighborhood eatery with burger favorites and craft beer, plus a relaxed atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e14-ea31-769a-ac74-967ce653863d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e14-ea31-769a-ac74-967ce653863d",
        "storage_key": "property/6737460151191752/019e1e14-ea31-769a-ac74-967ce653863d.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "http://eatatthegarage.com/locations/the-garage-stillwater/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3863479122271311011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-garage-burgers--beer",
      "poi_latitude": "36.1224122",
      "poi_longitude": "-97.0649053",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-332-5560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-25ea-735b-81fd-332aa927e4ed",
        "storage_key": "property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk9Uh3DgKsYcRo5QeyMrVnTU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_936518a8-3b24-4b57-96e1-091c516cad80",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Empire Slice House - Stillwater",
      "poi_type": "Restaurants",
      "poi_address": "116 W 10th Ave, Stillwater, OK 74074, USA",
      "poi_short_description": "New York–style pies served whole or by the slice, along with an assortment of appetizers, in a laid-back setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e14-f173-76cd-9795-331ce90394d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e14-f173-76cd-9795-331ce90394d6",
        "storage_key": "property/6737460151191752/019e1e14-f173-76cd-9795-331ce90394d6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.empireslicepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13453813691233595808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "empire-slice-house---stillwater",
      "poi_latitude": "36.1114847",
      "poi_longitude": "-97.0594433",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-937-0776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-25ea-735b-81fd-332aa927e4ed",
        "storage_key": "property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvX1jmYsLsYcRoPFDVEWMtbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_d24ede6c-b3e5-486f-84d6-22f6d79748b7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Stonecloud Stillwater Patio & Taproom",
      "poi_type": "Restaurants",
      "poi_address": "917 S Husband St, Stillwater, OK 74074, USA",
      "poi_short_description": "Family-friendly brewpub featuring craft beers and a spacious patio with shade trees.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e14-f1df-726d-9450-62c958c873a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e14-f1df-726d-9450-62c958c873a9",
        "storage_key": "property/6737460151191752/019e1e14-f1df-726d-9450-62c958c873a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stonecloudbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10387932246300072184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stonecloud-stillwater-patio--taproom",
      "poi_latitude": "36.111695",
      "poi_longitude": "-97.059682",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-338-9599",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-2d17-7719-85d6-87c6f2033c18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-2d17-7719-85d6-87c6f2033c18",
        "storage_key": "property/6737460151191752/019e1e15-2d17-7719-85d6-87c6f2033c18.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ0gseAILsYcR-JiKI1dZKZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_8bebb099-dfab-4be8-9271-d8b98679a773",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Granny's Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "701 S Main St, Stillwater, OK 74074, USA",
      "poi_short_description": "Popular daytime spot serving American breakfast classics & Southern eats in cozy, no-frills digs.",
      "poi_long_description": "Popular daytime spot serving American breakfast classics & Southern eats in cozy, no-frills digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e14-eb28-70cb-94f3-3752804e9032.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e14-eb28-70cb-94f3-3752804e9032",
        "storage_key": "property/6737460151191752/019e1e14-eb28-70cb-94f3-3752804e9032.webp",
        "width": 1280,
        "height": 962
      },
      "poi_business_url": "http://www.grannyskitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8197306793480673511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grannys-kitchen",
      "poi_latitude": "36.1143768",
      "poi_longitude": "-97.0582487",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-743-1299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-25ea-735b-81fd-332aa927e4ed",
        "storage_key": "property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh0H3x08KsYcR59hP9BivwnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_0605e222-b9f6-4424-954b-05e3aac8ed38",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Da Vinci's Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2280 N Perkins Rd, Stillwater, OK 74075, USA",
      "poi_short_description": "A range of Italian comfort food & wine served in easygoing surrounds with many booths.",
      "poi_long_description": "A range of Italian comfort food & wine served in easygoing surrounds with many booths.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e14-ec53-771b-9208-50d48a78413f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e14-ec53-771b-9208-50d48a78413f",
        "storage_key": "property/6737460151191752/019e1e14-ec53-771b-9208-50d48a78413f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://davincistillwater.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3649692355505838344&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "da-vincis-italian-restaurant",
      "poi_latitude": "36.1446624",
      "poi_longitude": "-97.0528626",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-372-0300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-25ea-735b-81fd-332aa927e4ed",
        "storage_key": "property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlzpgTIAJsYcRCFliRdxPpjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_308ac418-0e52-4e1a-9c60-478c91c3ddcd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Louie's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "720 S Main St, Stillwater, OK 74074, USA",
      "poi_short_description": "Casual hangout with sports on TV & a menu of classic American pub fare.",
      "poi_long_description": "Casual hangout with sports on TV & a menu of classic American pub fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e14-ea13-756c-85d0-3315c178af0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e14-ea13-756c-85d0-3315c178af0a",
        "storage_key": "property/6737460151191752/019e1e14-ea13-756c-85d0-3315c178af0a.webp",
        "width": 857,
        "height": 450
      },
      "poi_business_url": "http://louiesgrillandbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13787150966588618211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "louies-grill--bar",
      "poi_latitude": "36.1137765",
      "poi_longitude": "-97.0587931",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-707-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-2d17-7719-85d6-87c6f2033c18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-2d17-7719-85d6-87c6f2033c18",
        "storage_key": "property/6737460151191752/019e1e15-2d17-7719-85d6-87c6f2033c18.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0XFaPE8KsYcR47UytMHMVb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_1935c24b-67c9-42b8-95fc-b15c73a5bc9c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Shortcake's Diner",
      "poi_type": "Restaurants",
      "poi_address": "219 N Main St, Stillwater, OK 74075, USA",
      "poi_short_description": "Casual breakfast joint serving American dishes such as pancakes and hash browns.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e14-eb82-720c-8bfc-e0783e5dbec3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e14-eb82-720c-8bfc-e0783e5dbec3",
        "storage_key": "property/6737460151191752/019e1e14-eb82-720c-8bfc-e0783e5dbec3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/ShortcakesDiner/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3791850535963552172&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shortcakes-diner",
      "poi_latitude": "36.1248171",
      "poi_longitude": "-97.0583085",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-624-1057",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-25ea-735b-81fd-332aa927e4ed",
        "storage_key": "property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJschx6lULsYcRrGl77fhbnzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_50f9ca20-9f0c-445b-9bb4-cb1d0b8620f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "The Ranchers Club",
      "poi_type": "Restaurants",
      "poi_address": "Student Union, S Hester St H103, Stillwater, OK 74078, USA",
      "poi_short_description": "High-end hotel steakhouse showcasing American classics & cocktails in a ranch-chic environment.",
      "poi_long_description": "High-end hotel steakhouse showcasing American classics & cocktails in a ranch-chic environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e14-ea18-72ee-8717-6f2c90e0e865.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e14-ea18-72ee-8717-6f2c90e0e865",
        "storage_key": "property/6737460151191752/019e1e14-ea18-72ee-8717-6f2c90e0e865.webp",
        "width": 400,
        "height": 600
      },
      "poi_business_url": "http://www.theranchersclub.com/?utm_source=google&utm_medium=organic&utm_campaign=business-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=14495995498725483948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-ranchers-club",
      "poi_latitude": "36.1204009",
      "poi_longitude": "-97.0687342",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-744-2333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-25ea-735b-81fd-332aa927e4ed",
        "storage_key": "property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm9yeDT8KsYcRrKUxXxofLMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_e72b91ad-4bb1-48e8-a742-f6f7e1d9e98e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Pickleman's Gourmet Cafe - Stillwater, OK",
      "poi_type": "Restaurants",
      "poi_address": "321 S Washington St, Stillwater, OK 74074, USA",
      "poi_short_description": "Counter-serve chain for toasted subs topped with a wide array of ingredients, plus salads & pizza.",
      "poi_long_description": "Counter-serve chain for toasted subs topped with a wide array of ingredients, plus salads & pizza.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e14-ed97-75fa-bfd4-f8b30fbbc176.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e14-ed97-75fa-bfd4-f8b30fbbc176",
        "storage_key": "property/6737460151191752/019e1e14-ed97-75fa-bfd4-f8b30fbbc176.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.picklemans.com/location/stillwater-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6834838095154286968&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "picklemans-gourmet-cafe---stillwater-ok",
      "poi_latitude": "36.1180649",
      "poi_longitude": "-97.0691939",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-384-7171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-25ea-735b-81fd-332aa927e4ed",
        "storage_key": "property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH0hTh0QLsYcReJH69gg52l4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_fe92e688-047f-4759-9b71-be44586178d1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Roscoe's Feed Shack",
      "poi_type": "Restaurants",
      "poi_address": "523 W 6th Ave, Stillwater, OK 74074, USA",
      "poi_short_description": "Southern comfort food is served for lunch and dinner at this casual restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e14-f16c-75ac-aa5e-53fe19369a6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e14-f16c-75ac-aa5e-53fe19369a6f",
        "storage_key": "property/6737460151191752/019e1e14-f16c-75ac-aa5e-53fe19369a6f.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12386768161541992397&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roscoes-feed-shack",
      "poi_latitude": "36.1153326",
      "poi_longitude": "-97.0649605",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-338-9330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-25ea-735b-81fd-332aa927e4ed",
        "storage_key": "property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN5fwtHULsYcRzS_U1wOk5qs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_ea2460bc-d904-4c66-87cd-8fce2127b622",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Zannotti's Wine Bar",
      "poi_type": "Restaurants",
      "poi_address": "113 W 7th Ave, Stillwater, OK 74074, USA",
      "poi_short_description": "Relaxed wine bar for cocktails, beer and an extensive menu of bistro pizzas and entrees.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e14-f378-753e-91b0-d99f62a68897.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e14-f378-753e-91b0-d99f62a68897",
        "storage_key": "property/6737460151191752/019e1e14-f378-753e-91b0-d99f62a68897.webp",
        "width": 1080,
        "height": 609
      },
      "poi_business_url": "http://www.zannottiswinebar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11209603709899633331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zannottis-wine-bar",
      "poi_latitude": "36.114343",
      "poi_longitude": "-97.0594051",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-707-7037",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-2d17-7719-85d6-87c6f2033c18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-2d17-7719-85d6-87c6f2033c18",
        "storage_key": "property/6737460151191752/019e1e15-2d17-7719-85d6-87c6f2033c18.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdenzeoigsYcRs_J34S6DkJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "custom_6d00d9d5-236f-432b-946f-64f4d13257d2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Mexico Joe's",
      "poi_type": "Restaurants",
      "poi_address": "311 E Hall of Fame Ave, Stillwater, OK 74075, USA",
      "poi_short_description": "Creative margaritas & a huge menu of Sonoran-Mexican eats with signature salsas in a festive space.",
      "poi_long_description": "Creative margaritas & a huge menu of Sonoran-Mexican eats with signature salsas in a festive space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e14-f7ad-76f5-aacb-a3a539da27e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e14-f7ad-76f5-aacb-a3a539da27e3",
        "storage_key": "property/6737460151191752/019e1e14-f7ad-76f5-aacb-a3a539da27e3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.mexicojoes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9758977856681992529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mexico-joes",
      "poi_latitude": "36.126421",
      "poi_longitude": "-97.055324",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-372-1169",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-25ea-735b-81fd-332aa927e4ed",
        "storage_key": "property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvQqAWTEKsYcRUeFuxqfaboc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_48106a37-1595-43cd-a71c-c34af1a7cbc4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "519 S Main St, Stillwater, OK 74074, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e14-f617-751f-a90b-c2f2e01ba6aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e14-f617-751f-a90b-c2f2e01ba6aa",
        "storage_key": "property/6737460151191752/019e1e14-f617-751f-a90b-c2f2e01ba6aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-519+s+main+st-stillwater-ok-74074/id=5530",
      "poi_directions_map_url": "https://maps.google.com/?cid=14962467368740384874&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "36.1161755",
      "poi_longitude": "-97.0576698",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-377-0349",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2672-700d-b6b0-7929505e5db2",
        "storage_key": "property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXZ_T3UgKsYcRavAkHcxcpc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_76ebfa7a-071e-4217-8744-f186a6623742",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Cowboy Corner",
      "poi_type": "Shopping & Retail",
      "poi_address": "524 S Duck St, Stillwater, OK 74074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e14-fa02-734d-bb15-f90eab80e89b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e14-fa02-734d-bb15-f90eab80e89b",
        "storage_key": "property/6737460151191752/019e1e14-fa02-734d-bb15-f90eab80e89b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10495400879648263660&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cowboy-corner",
      "poi_latitude": "36.1159565",
      "poi_longitude": "-97.0630988",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-377-3377",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-2d06-7125-a985-815549e89ca2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-2d06-7125-a985-815549e89ca2",
        "storage_key": "property/6737460151191752/019e1e15-2d06-7125-a985-815549e89ca2.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJiTdUYEYKsYcR7M3BNn4np5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_abe1927d-dde4-4981-9c48-222efb51070e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "909 W 6th Ave, Stillwater, OK 74074, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e12-f6c4-70ad-98ad-8505f76a8eda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-f6c4-70ad-98ad-8505f76a8eda",
        "storage_key": "property/6737460151191752/019e1e12-f6c4-70ad-98ad-8505f76a8eda.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sprouts.com/store/ok/stillwater/stillwater",
      "poi_directions_map_url": "https://maps.google.com/?cid=17213488227561966360&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "36.1153173",
      "poi_longitude": "-97.0702697",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-571-3153",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2675-747f-9921-b5ba6f91dc4c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2675-747f-9921-b5ba6f91dc4c",
        "storage_key": "property/6737460151191752/019e1e13-2675-747f-9921-b5ba6f91dc4c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvWv260EKsYcRGAszjVeY4u4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_feb6e8a5-d2ac-4a05-a721-a3afe2436085",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "1188 N Perkins Rd, Stillwater, OK 74075, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e12-f747-721a-833d-eec8b12b4564.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-f747-721a-833d-eec8b12b4564",
        "storage_key": "property/6737460151191752/019e1e12-f747-721a-833d-eec8b12b4564.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ok/stillwater/1188-n-perkins-rd/l799",
      "poi_directions_map_url": "https://maps.google.com/?cid=8535579607082340440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "36.13427",
      "poi_longitude": "-97.05146",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2675-747f-9921-b5ba6f91dc4c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2675-747f-9921-b5ba6f91dc4c",
        "storage_key": "property/6737460151191752/019e1e13-2675-747f-9921-b5ba6f91dc4c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkUwe4iwKsYcRWBA24G14dHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_a772fe0d-f030-41ea-9926-2c7493f101c9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Homeland",
      "poi_type": "Shopping & Retail",
      "poi_address": "421 N Main St, Stillwater, OK 74075, USA",
      "poi_short_description": "Supermarket chain selling groceries, meats, produce, baked goods and deli items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e14-fe5d-741a-be05-00e30e76d819.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e14-fe5d-741a-be05-00e30e76d819",
        "storage_key": "property/6737460151191752/019e1e14-fe5d-741a-be05-00e30e76d819.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homelandstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10662061821371060669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "homeland",
      "poi_latitude": "36.1277889",
      "poi_longitude": "-97.0568184",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-743-1086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2675-747f-9921-b5ba6f91dc4c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2675-747f-9921-b5ba6f91dc4c",
        "storage_key": "property/6737460151191752/019e1e13-2675-747f-9921-b5ba6f91dc4c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzVOAGTEKsYcRvZETjLxA95M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_06fc02af-90f1-4b86-9ec3-2cdbd8322a12",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "4545 W 6th Ave, Stillwater, OK 74074, USA",
      "poi_short_description": "Department store chain carrying everything from apparel and electronics to toys and groceries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e14-fe4c-7619-84ec-664254498d7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e14-fe4c-7619-84ec-664254498d7d",
        "storage_key": "property/6737460151191752/019e1e14-fe4c-7619-84ec-664254498d7d.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/4241-stillwater-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=15883440626856001284&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "36.1138696",
      "poi_longitude": "-97.119282",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-707-0744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2603-7408-ab45-a421094b4d34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2603-7408-ab45-a421094b4d34",
        "storage_key": "property/6737460151191752/019e1e13-2603-7408-ab45-a421094b4d34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPQvSLeqgsYcRBH_ClhhRbdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_0c8a1ff9-50c1-4d75-9ac0-c57489287868",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1616 N Perkins Rd, Stillwater, OK 74075, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e14-fd95-755f-895f-a8a0654d102b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e14-fd95-755f-895f-a8a0654d102b",
        "storage_key": "property/6737460151191752/019e1e14-fd95-755f-895f-a8a0654d102b.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Stillwater/0241?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-241-_-na-_-0-_-0&y_source=1_MTE4MzI1NC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13366612161353035125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "36.138947",
      "poi_longitude": "-97.0533631",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-377-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2603-7408-ab45-a421094b4d34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2603-7408-ab45-a421094b4d34",
        "storage_key": "property/6737460151191752/019e1e13-2603-7408-ab45-a421094b4d34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_1pj5SoKsYcRdS3d__C-f7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_9e27f264-f7be-47c8-a46a-5d63947a7fbd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "1198 N Perkins Rd, Stillwater, OK 74075, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e14-fe5c-7319-a3de-9ac0f1252dd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e14-fe5c-7319-a3de-9ac0f1252dd3",
        "storage_key": "property/6737460151191752/019e1e14-fe5c-7319-a3de-9ac0f1252dd3.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/ok/stillwater/1198-n-perkins-rd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=15772336780539616683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "36.1344898",
      "poi_longitude": "-97.0525075",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-225-0767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2603-7408-ab45-a421094b4d34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2603-7408-ab45-a421094b4d34",
        "storage_key": "property/6737460151191752/019e1e13-2603-7408-ab45-a421094b4d34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxZMkCC0KsYcRq13kibyY4to",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_3301efc1-3244-4c3b-871b-26f28b7016fa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "101 E Hall of Fame Ave, Stillwater, OK 74075, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e14-fe45-7178-8862-e4485fabe5f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e14-fe45-7178-8862-e4485fabe5f5",
        "storage_key": "property/6737460151191752/019e1e14-fe45-7178-8862-e4485fabe5f5.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/stillwater-ok-pharmacies/101-e-hall-of-fame-ave-stillwater-ok-74075/storeid=10101?WT.mc_id=LS_GOOGLE_RX_10101",
      "poi_directions_map_url": "https://maps.google.com/?cid=13580533280976004035&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "36.1264154",
      "poi_longitude": "-97.05800010000002",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-707-0287",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-2d07-727e-aa2e-900fc65b6776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-2d07-727e-aa2e-900fc65b6776",
        "storage_key": "property/6737460151191752/019e1e15-2d07-727e-aa2e-900fc65b6776.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi7xMKDEKsYcRw-Px-BC_d7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_dc087a7c-ad87-45ca-961b-58df609562b3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "OnCue Express",
      "poi_type": "Shopping & Retail",
      "poi_address": "2101 E 6th Ave, Stillwater, OK 74074, USA",
      "poi_short_description": "Gas station & convenience store chain with car washes offering a variety of beverages & food.",
      "poi_long_description": "Gas station & convenience store chain with car washes offering a variety of beverages & food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-0457-730f-a809-149bf299a93b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-0457-730f-a809-149bf299a93b",
        "storage_key": "property/6737460151191752/019e1e15-0457-730f-a809-149bf299a93b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oncue.com/?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5546121058583280052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oncue-express",
      "poi_latitude": "36.1156225",
      "poi_longitude": "-97.0331681",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-624-1909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-2d06-7125-a985-815549e89ca2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-2d06-7125-a985-815549e89ca2",
        "storage_key": "property/6737460151191752/019e1e15-2d06-7125-a985-815549e89ca2.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJwyxOBLwLsYcRtHkr2rfH90w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_b6ff0aa8-b295-4fd6-bdd8-2683f9a0acd5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Will Rogers Elementary",
      "poi_type": "Education",
      "poi_address": "1211 N Washington St, Stillwater, OK 74075, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-007c-723d-99fe-7a21671e3584.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-007c-723d-99fe-7a21671e3584",
        "storage_key": "property/6737460151191752/019e1e15-007c-723d-99fe-7a21671e3584.webp",
        "width": 861,
        "height": 428
      },
      "poi_business_url": "https://www.stillwaterschools.com/Schools/WillRogers",
      "poi_directions_map_url": "https://maps.google.com/?cid=28207178536596627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "will-rogers-elementary",
      "poi_latitude": "36.1351834",
      "poi_longitude": "-97.0682917",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-533-6380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262b-73ff-9b6f-331284cf0c80",
        "storage_key": "property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo3M_SiIKsYcRkzTKiEc2ZAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_b6da2502-4c74-4800-a88f-b7d1289e6524",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Highland Park Elementary School",
      "poi_type": "Education",
      "poi_address": "400 S Drury St, Stillwater, OK 74074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.stillwaterschools.com/Schools/HighlandPark",
      "poi_directions_map_url": "https://maps.google.com/?cid=14894555502342301949&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "highland-park-elementary-school",
      "poi_latitude": "36.1190806",
      "poi_longitude": "-97.0268787",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-533-6350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262b-73ff-9b6f-331284cf0c80",
        "storage_key": "property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJj387rLcLsYcR_ehzjFAXtM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_33eed884-a940-4a5d-bee8-1418c4863700",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Westwood Elementary School",
      "poi_type": "Education",
      "poi_address": "502 S Kings St, Stillwater, OK 74074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-017d-7129-84ff-1bdbcb54b484.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-017d-7129-84ff-1bdbcb54b484",
        "storage_key": "property/6737460151191752/019e1e15-017d-7129-84ff-1bdbcb54b484.webp",
        "width": 861,
        "height": 428
      },
      "poi_business_url": "https://www.stillwaterschools.com/Schools/Westwood",
      "poi_directions_map_url": "https://maps.google.com/?cid=17317008253487163485&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westwood-elementary-school",
      "poi_latitude": "36.1164671",
      "poi_longitude": "-97.0821766",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-533-6370",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262b-73ff-9b6f-331284cf0c80",
        "storage_key": "property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4-txcW0KsYcRXSic0UFfUvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d90db34b-2815-472e-aa3d-d02380cbbe7d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Sangre Ridge Elementary School",
      "poi_type": "Education",
      "poi_address": "2500 S Sangre Rd, Stillwater, OK 74074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-0267-756c-b41c-aee47606e626.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-0267-756c-b41c-aee47606e626",
        "storage_key": "property/6737460151191752/019e1e15-0267-756c-b41c-aee47606e626.webp",
        "width": 861,
        "height": 428
      },
      "poi_business_url": "https://www.stillwaterschools.com/Schools/SangreRidge",
      "poi_directions_map_url": "https://maps.google.com/?cid=18148430220442074376&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sangre-ridge-elementary-school",
      "poi_latitude": "36.0947441",
      "poi_longitude": "-97.1055017",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-533-6360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262b-73ff-9b6f-331284cf0c80",
        "storage_key": "property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlXw0wGKgsYcRCP1piCEt3Ps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f99e533b-94e0-41a6-b81f-b07ef9fbde1d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Skyline Elementary School",
      "poi_type": "Education",
      "poi_address": "1402 E Sunrise Ave, Stillwater, OK 74075, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-01de-7067-9854-3347fe6a9bc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-01de-7067-9854-3347fe6a9bc3",
        "storage_key": "property/6737460151191752/019e1e15-01de-7067-9854-3347fe6a9bc3.webp",
        "width": 861,
        "height": 428
      },
      "poi_business_url": "https://www.stillwaterschools.com/Schools/Skyline",
      "poi_directions_map_url": "https://maps.google.com/?cid=1806360932597746042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skyline-elementary-school",
      "poi_latitude": "36.1384744",
      "poi_longitude": "-97.0413354",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-533-6390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262b-73ff-9b6f-331284cf0c80",
        "storage_key": "property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGdRG1NYLsYcResmhm7J7ERk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c7d2211f-951b-4056-b3ec-4d404f8f0849",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Stillwater Middle School",
      "poi_type": "Education",
      "poi_address": "2200 S Sangre Rd, Stillwater, OK 74074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-0286-72be-879b-808f909a726b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-0286-72be-879b-808f909a726b",
        "storage_key": "property/6737460151191752/019e1e15-0286-72be-879b-808f909a726b.webp",
        "width": 861,
        "height": 428
      },
      "poi_business_url": "https://www.stillwaterschools.com/Schools/MiddleSchool",
      "poi_directions_map_url": "https://maps.google.com/?cid=848229340336123365&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stillwater-middle-school",
      "poi_latitude": "36.0968627",
      "poi_longitude": "-97.1060132",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-533-6430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262b-73ff-9b6f-331284cf0c80",
        "storage_key": "property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJafNe2ImgsYcR5W3MRheExQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6ea545a0-f0dd-42dc-9dd8-0ac75f28f196",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Stillwater Junior High School",
      "poi_type": "Education",
      "poi_address": "1900 N Skyline St, Stillwater, OK 74075, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-03b1-727b-9018-f7dfcc730f2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-03b1-727b-9018-f7dfcc730f2f",
        "storage_key": "property/6737460151191752/019e1e15-03b1-727b-9018-f7dfcc730f2f.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "https://www.stillwaterschools.com/Schools/JuniorHigh",
      "poi_directions_map_url": "https://maps.google.com/?cid=3845618437230568975&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stillwater-junior-high-school",
      "poi_latitude": "36.1404191",
      "poi_longitude": "-97.0388421",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-533-6420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262b-73ff-9b6f-331284cf0c80",
        "storage_key": "property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf-BUzNkLsYcRDybS_JdhXjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_56649f69-00f3-4d52-aeca-f889f2967355",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Stillwater High School",
      "poi_type": "Education",
      "poi_address": "1224 N Husband St, Stillwater, OK 74075, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-0339-7609-bd96-f8effe31bcab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-0339-7609-bd96-f8effe31bcab",
        "storage_key": "property/6737460151191752/019e1e15-0339-7609-bd96-f8effe31bcab.webp",
        "width": 861,
        "height": 428
      },
      "poi_business_url": "https://www.stillwaterschools.com/Schools/HighSchool",
      "poi_directions_map_url": "https://maps.google.com/?cid=11393796009921701222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stillwater-high-school",
      "poi_latitude": "36.135089",
      "poi_longitude": "-97.062079",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-533-6450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262b-73ff-9b6f-331284cf0c80",
        "storage_key": "property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJec074iUKsYcRZmWlphrlHp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_620bd720-8397-420c-948c-a7226c8240d3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Oklahoma State University",
      "poi_type": "Education",
      "poi_address": "Stillwater, OK, USA",
      "poi_short_description": "Sizable public university founded in 1890 & known for its athletics, science & business programs.",
      "poi_long_description": "Sizable public university founded in 1890 & known for its athletics, science & business programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e12-fab9-724d-8de0-5363251ef40d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-fab9-724d-8de0-5363251ef40d",
        "storage_key": "property/6737460151191752/019e1e12-fab9-724d-8de0-5363251ef40d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://go.okstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2634290143846533996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oklahoma-state-university",
      "poi_latitude": "36.126572",
      "poi_longitude": "-97.0734821",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-744-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262b-73ff-9b6f-331284cf0c80",
        "storage_key": "property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_3VGkxYKsYcRbAtJw-3gjiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9a000a56-7b8d-4098-8a48-ab55e167adbc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "AMC Stillwater 10",
      "poi_type": "Entertainment",
      "poi_address": "1909 N Perkins Rd, Stillwater, OK 74074, USA",
      "poi_short_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_long_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-068b-762f-94a6-0df726284248.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-068b-762f-94a6-0df726284248",
        "storage_key": "property/6737460151191752/019e1e15-068b-762f-94a6-0df726284248.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/oklahoma-city/amc-stillwater-10?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11020525961853575581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-stillwater-10",
      "poi_latitude": "36.13978000000001",
      "poi_longitude": "-97.0499667",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-372-0349",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-2d18-729a-9e18-102d908e8bca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-2d18-729a-9e18-102d908e8bca",
        "storage_key": "property/6737460151191752/019e1e15-2d18-729a-9e18-102d908e8bca.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJld-c0EgKsYcRnaFAGvnF8Jg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_c52e45ad-4c4b-40b0-b45a-0d96d258e6c5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "McKnight Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "705 W University Ave, Stillwater, OK 74074, USA",
      "poi_short_description": "High-tech concert venue at Oklahoma State University, featuring performances by celebrated artists and bands.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-06da-719e-8aa2-f9f45aa1f6e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-06da-719e-8aa2-f9f45aa1f6e3",
        "storage_key": "property/6737460151191752/019e1e15-06da-719e-8aa2-f9f45aa1f6e3.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "https://mcknightcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7881670660544759503&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcknight-center-for-the-performing-arts",
      "poi_latitude": "36.1192347",
      "poi_longitude": "-97.0673102",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-744-9999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2672-700d-b6b0-7929505e5db2",
        "storage_key": "property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0aGFz74LsYcRz4Zj9rRRYW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_74fd4df3-8d35-4af7-91d9-62f0398c6946",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Tumbleweed Dancehall & Concert Venue",
      "poi_type": "Entertainment",
      "poi_address": "Lakeview &, N Country Club Rd, Stillwater, OK 74075, USA",
      "poi_short_description": "Venue hosting concerts and other events in a rustic rockabilly-style setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-0624-76ee-bbdd-ad5519e9bdd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-0624-76ee-bbdd-ad5519e9bdd8",
        "storage_key": "property/6737460151191752/019e1e15-0624-76ee-bbdd-ad5519e9bdd8.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "http://calffry.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17579664350257345791&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tumbleweed-dancehall--concert-venue",
      "poi_latitude": "36.1456779",
      "poi_longitude": "-97.12632390000002",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-792-0009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2672-700d-b6b0-7929505e5db2",
        "storage_key": "property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1dqFNi6nsYcR__Sv45WD9_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_b4e308a7-db0f-4619-8ab9-6200243a0082",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "OSU Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "720 S Husband St, Stillwater, OK 74074, USA",
      "poi_short_description": "Small art museum with ever-changing exhibits & creative events, including children's activities.",
      "poi_long_description": "Small art museum with ever-changing exhibits & creative events, including children's activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-0351-700f-9895-1720b48e642a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e13-0351-700f-9895-1720b48e642a",
        "storage_key": "property/6737460151191752/019e1e13-0351-700f-9895-1720b48e642a.webp",
        "width": 1280,
        "height": 831
      },
      "poi_business_url": "http://museum.okstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8182424361347680286&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "osu-museum-of-art",
      "poi_latitude": "36.1139328",
      "poi_longitude": "-97.0603131",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-744-2780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-260c-71c9-a6bf-1eebb3481791.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-260c-71c9-a6bf-1eebb3481791",
        "storage_key": "property/6737460151191752/019e1e13-260c-71c9-a6bf-1eebb3481791.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJmVVUXk8KsYcRHoihs5rPjXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f0503249-22a3-4cb8-9bda-a994e2542c54",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Stillwater History Museum at the Sheerar",
      "poi_type": "Entertainment",
      "poi_address": "702 S Duncan St, Stillwater, OK 74074, USA",
      "poi_short_description": "This museum offers exhibits exploring the history of the region from the 1880s to the present.",
      "poi_long_description": "This museum offers exhibits exploring the history of the region from the 1880s to the present.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-06fb-727e-8987-9ef5dd8eebc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-06fb-727e-8987-9ef5dd8eebc9",
        "storage_key": "property/6737460151191752/019e1e15-06fb-727e-8987-9ef5dd8eebc9.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.stillwaterokhistory.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4045412650102932138&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stillwater-history-museum-at-the-sheerar",
      "poi_latitude": "36.1143155",
      "poi_longitude": "-97.0616801",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-377-0359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-260c-71c9-a6bf-1eebb3481791.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-260c-71c9-a6bf-1eebb3481791",
        "storage_key": "property/6737460151191752/019e1e13-260c-71c9-a6bf-1eebb3481791.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ3yl5EUKsYcRqsJBK18xJDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_a21fefca-c91f-439c-b097-d578ba5f13ce",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Prairie Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "1001 S Duck St, Stillwater, OK 74074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-0936-77de-9d9c-ff578f422d2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-0936-77de-9d9c-ff578f422d2a",
        "storage_key": "property/6737460151191752/019e1e15-0936-77de-9d9c-ff578f422d2a.webp",
        "width": 958,
        "height": 1280
      },
      "poi_business_url": "http://artscenter.okstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5561737539615922181&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prairie-arts-center",
      "poi_latitude": "36.1109754",
      "poi_longitude": "-97.0617542",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-744-1535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2672-700d-b6b0-7929505e5db2",
        "storage_key": "property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU-yhGkUKsYcRBRjDLtNCL00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f8f849d0-8ed7-47bb-87aa-0f474bec16ab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Eskimo Joe's",
      "poi_type": "Entertainment",
      "poi_address": "501 W Elm Ave, Stillwater, OK 74074, USA",
      "poi_short_description": "American fare in a busy sports bar with a jukebox, pool tables, live music & a rooftop patio.",
      "poi_long_description": "American fare in a busy sports bar with a jukebox, pool tables, live music & a rooftop patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e12-f164-75be-a25b-f3bf22c72321.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-f164-75be-a25b-f3bf22c72321",
        "storage_key": "property/6737460151191752/019e1e12-f164-75be-a25b-f3bf22c72321.webp",
        "width": 850,
        "height": 315
      },
      "poi_business_url": "http://www.eskimojoes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12988840321115084949&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eskimo-joes",
      "poi_latitude": "36.1218994",
      "poi_longitude": "-97.0641617",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-372-8896",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-25ea-735b-81fd-332aa927e4ed",
        "storage_key": "property/6737460151191752/019e1e13-25ea-735b-81fd-332aa927e4ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtf-p7zgKsYcRldhVSHShQbQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_2a2d16f5-52ba-45bd-9454-8fb7cb0a5b92",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Iron Monk Brewing Company",
      "poi_type": "Entertainment",
      "poi_address": "519 S Husband St, Stillwater, OK 74074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-0ae8-74c8-838b-186abb693f50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-0ae8-74c8-838b-186abb693f50",
        "storage_key": "property/6737460151191752/019e1e15-0ae8-74c8-838b-186abb693f50.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ironmonkbeer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8069504151623996228&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iron-monk-brewing-company",
      "poi_latitude": "36.1159827",
      "poi_longitude": "-97.059726",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-714-2585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2672-700d-b6b0-7929505e5db2",
        "storage_key": "property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf677mUgKsYcRRJMWl0Wj_G8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_3ee7ccca-5530-4b28-a248-a1a8cd139fa9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Town & Gown Community Theatre",
      "poi_type": "Entertainment",
      "poi_address": "3524 S Perkins Rd, Stillwater, OK 74074, USA",
      "poi_short_description": "Casual, well-regarded performance venue featuring a variety of productions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-0a5d-704d-97e9-4b012d6089de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-0a5d-704d-97e9-4b012d6089de",
        "storage_key": "property/6737460151191752/019e1e15-0a5d-704d-97e9-4b012d6089de.webp",
        "width": 1280,
        "height": 725
      },
      "poi_business_url": "http://www.townandgown.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11647490566562352980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town--gown-community-theatre",
      "poi_latitude": "36.0823939",
      "poi_longitude": "-97.0519689",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-372-9122",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2672-700d-b6b0-7929505e5db2",
        "storage_key": "property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH1vRIeIKsYcRVI-pkPUypKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_4c8a3995-9af3-4605-8e61-52c15138fe65",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Stillwater Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1323 W 6th Ave, Stillwater, OK 74074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-1289-7630-baf1-1ab03ca713de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e13-1289-7630-baf1-1ab03ca713de",
        "storage_key": "property/6737460151191752/019e1e13-1289-7630-baf1-1ab03ca713de.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.stillwater-medical.org/locations/stillwater-medical-center?utm_source=extnet&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=9202220144040975116&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stillwater-medical-center",
      "poi_latitude": "36.1150477",
      "poi_longitude": "-97.0751781",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-372-1480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262a-737b-b5dc-426616892ad3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262a-737b-b5dc-426616892ad3",
        "storage_key": "property/6737460151191752/019e1e13-262a-737b-b5dc-426616892ad3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE9RWyWsKsYcRDJuBLnfatH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_65a9727e-5c0d-4543-b413-b475daced05c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "AMC Urgent Care Plus - Stillwater",
      "poi_type": "Health and Wellness",
      "poi_address": "1909 W 6th Ave B, Stillwater, OK 74074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-0d99-74a8-9a80-4559a33d6b9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-0d99-74a8-9a80-4559a33d6b9e",
        "storage_key": "property/6737460151191752/019e1e15-0d99-74a8-9a80-4559a33d6b9e.webp",
        "width": 1192,
        "height": 1280
      },
      "poi_business_url": "https://amcurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10426102015880804834&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-urgent-care-plus---stillwater",
      "poi_latitude": "36.115452",
      "poi_longitude": "-97.0820193",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-385-0029",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2672-700d-b6b0-7929505e5db2",
        "storage_key": "property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkU8MiW0KsYcR4jmPKIv0sJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_956e099a-fb11-4a0e-9daf-db9f76614ab0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Oklahoma State University : Health Services",
      "poi_type": "Health and Wellness",
      "poi_address": "1202 W Farm Rd, Stillwater, OK 74078, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-0c0d-7248-b37e-963a8091d721.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-0c0d-7248-b37e-963a8091d721",
        "storage_key": "property/6737460151191752/019e1e15-0c0d-7248-b37e-963a8091d721.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://uhs.okstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9176782439041618053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oklahoma-state-university--health-services",
      "poi_latitude": "36.1249934",
      "poi_longitude": "-97.0739292",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-744-7665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2672-700d-b6b0-7929505e5db2",
        "storage_key": "property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6RxFkA4KsYcRhVAe9AF7Wn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_0cebdcbb-6650-4799-b4c3-4ef0692ccb7f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "519 S Main St, Stillwater, OK 74074, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-0d37-76af-808f-8427e067d039.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-0d37-76af-808f-8427e067d039",
        "storage_key": "property/6737460151191752/019e1e15-0d37-76af-808f-8427e067d039.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-519+s+main+st-stillwater-ok-74074/id=5530",
      "poi_directions_map_url": "https://maps.google.com/?cid=10273145390438064277&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "36.1161983",
      "poi_longitude": "-97.0576537",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-377-0349",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-2d07-727e-aa2e-900fc65b6776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-2d07-727e-aa2e-900fc65b6776",
        "storage_key": "property/6737460151191752/019e1e15-2d07-727e-aa2e-900fc65b6776.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsT2fIUkKsYcRlaAAm02LkY4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_5bf7d7f3-b326-4688-8c90-c39238059d55",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Homeland Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "421 N Main St, Stillwater, OK 74075, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-0f3c-752a-b7d9-e614980370a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-0f3c-752a-b7d9-e614980370a3",
        "storage_key": "property/6737460151191752/019e1e15-0f3c-752a-b7d9-e614980370a3.webp",
        "width": 1280,
        "height": 937
      },
      "poi_business_url": "https://hacweb.rxtouch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14307867619864373020&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "homeland-pharmacy",
      "poi_latitude": "36.127612",
      "poi_longitude": "-97.0571549",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-743-1080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2603-7408-ab45-a421094b4d34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2603-7408-ab45-a421094b4d34",
        "storage_key": "property/6737460151191752/019e1e13-2603-7408-ab45-a421094b4d34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJK83ya_zSkYcRHGdUP8vBj8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_754878e6-ee30-4e82-85e4-0343eaffd445",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "805 E Virginia Ave, Stillwater, OK 74075, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-060a-706a-a551-6f056bcdf48a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e13-060a-706a-a551-6f056bcdf48a",
        "storage_key": "property/6737460151191752/019e1e13-060a-706a-a551-6f056bcdf48a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/stillwater-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=9923823085486031459&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.1223427",
      "poi_longitude": "-97.049198",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-338-1818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2672-700d-b6b0-7929505e5db2",
        "storage_key": "property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh-fdYUkLsYcRY0I3gISAuIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0aafa079-ad2a-470a-b46d-c95894896ed4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "705 N Main St, Stillwater, OK 74075, USA",
      "poi_short_description": "Personal and group training spot offering 60-minute workouts, including cardio and strength exercises.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-11fa-7151-aaef-8c10fbae3ab0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-11fa-7151-aaef-8c10fbae3ab0",
        "storage_key": "property/6737460151191752/019e1e15-11fa-7151-aaef-8c10fbae3ab0.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/stillwater-oklahoma-1238?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=7571021307936775022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "36.1298603",
      "poi_longitude": "-97.0572142",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-296-4631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2672-700d-b6b0-7929505e5db2",
        "storage_key": "property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs3cQr3wLsYcRbht8PsSrEWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8568f34b-7c6d-4621-b50f-16da44d5328c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "HOTWORX - Stillwater, OK",
      "poi_type": "Health and Wellness",
      "poi_address": "1950 N Perkins Rd, Stillwater, OK 74075, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-1053-73ba-a8df-b07d1e386772.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-1053-73ba-a8df-b07d1e386772",
        "storage_key": "property/6737460151191752/019e1e15-1053-73ba-a8df-b07d1e386772.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.hotworx.net/studio/stillwater?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=13298035111921711221&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---stillwater-ok",
      "poi_latitude": "36.141754",
      "poi_longitude": "-97.0538144",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-743-4405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262b-73ff-9b6f-331284cf0c80",
        "storage_key": "property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn8NU7XkLsYcRdfjDcHocjLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_2e3a7974-4e91-4ccc-88bd-c157b8b675c7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Red Earth Yoga Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1106 S Main St, Stillwater, OK 74074, USA",
      "poi_short_description": "Yoga studio offering heated and non-heated classes in Vinyasa, Hatha, and Ashtanga styles.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-12c0-7123-adb7-62cccce44353.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-12c0-7123-adb7-62cccce44353",
        "storage_key": "property/6737460151191752/019e1e15-12c0-7123-adb7-62cccce44353.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.redearthyogacenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14943708438191959995&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-earth-yoga-center",
      "poi_latitude": "36.1098461",
      "poi_longitude": "-97.0590253",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-714-1454",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262b-73ff-9b6f-331284cf0c80",
        "storage_key": "property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1erB3k8KsYcRu29wPaa3Ys8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_99a2765c-f907-4531-aa91-75f746bd5a15",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Southern Woods Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "600 W 12th Ave, Stillwater, OK 74074, USA",
      "poi_short_description": "Green space with basketball courts, ballfields, a splash pad & a playground, plus a dog park.",
      "poi_long_description": "Green space with basketball courts, ballfields, a splash pad & a playground, plus a dog park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-154e-7058-9194-e776e0a96620.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-154e-7058-9194-e776e0a96620",
        "storage_key": "property/6737460151191752/019e1e15-154e-7058-9194-e776e0a96620.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://stillwater.org/page/home/community/parks-trails-open-spaces",
      "poi_directions_map_url": "https://maps.google.com/?cid=8615085267778376451&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southern-woods-park",
      "poi_latitude": "36.1095039",
      "poi_longitude": "-97.067491",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-747-8070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262e-738b-a8aa-405a2abe1808.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262e-738b-a8aa-405a2abe1808",
        "storage_key": "property/6737460151191752/019e1e13-262e-738b-a8aa-405a2abe1808.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNXrFN0MKsYcRA5OhB2jujnc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8000bcc4-70d3-46b6-99b3-be5a8c68bc35",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Couch Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Stillwater, OK 74074, USA",
      "poi_short_description": "Sizable green space for recreation, with a community pool, disc golf & walking paths.",
      "poi_long_description": "Sizable green space for recreation, with a community pool, disc golf & walking paths.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-16ef-720c-90be-046037d3f31a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e13-16ef-720c-90be-046037d3f31a",
        "storage_key": "property/6737460151191752/019e1e13-16ef-720c-90be-046037d3f31a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stillwaterok.gov/449/Couch-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=515175361373840431&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "couch-park",
      "poi_latitude": "36.1069347",
      "poi_longitude": "-97.0451392",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-747-8070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262e-738b-a8aa-405a2abe1808.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262e-738b-a8aa-405a2abe1808",
        "storage_key": "property/6737460151191752/019e1e13-262e-738b-a8aa-405a2abe1808.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJD6N0PawLsYcRL6S4-0JFJgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a5623ceb-f7d9-4f56-ba0a-ed54c442701a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Boomer Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2310 E Lakeview Rd, Stillwater, OK 74075, USA",
      "poi_short_description": "Waterfront park with fishing, boating & amenities such as a disc-golf course, splash pad & trails.",
      "poi_long_description": "Waterfront park with fishing, boating & amenities such as a disc-golf course, splash pad & trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-1998-7559-813b-dfdfe49afcff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e13-1998-7559-813b-dfdfe49afcff",
        "storage_key": "property/6737460151191752/019e1e13-1998-7559-813b-dfdfe49afcff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://stillwater.org/page/home/community/parks-trails-open-spaces",
      "poi_directions_map_url": "https://maps.google.com/?cid=15350553639611141926&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boomer-lake-park",
      "poi_latitude": "36.1503952",
      "poi_longitude": "-97.0601109",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-747-8070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262e-738b-a8aa-405a2abe1808.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262e-738b-a8aa-405a2abe1808",
        "storage_key": "property/6737460151191752/019e1e13-262e-738b-a8aa-405a2abe1808.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPWVr1I8JsYcRJg-aWjQfCNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5c20f4e8-421f-48a4-b279-1c82d9936ce3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "The Botanic Garden at Oklahoma State University",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3300 W. 6th Street, (south entrance), Stillwater, OK 74078, USA",
      "poi_short_description": "University-affiliated gardens & arboretum with walking trails through a variety of themed displays.",
      "poi_long_description": "University-affiliated gardens & arboretum with walking trails through a variety of themed displays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-16c9-7629-9727-947e68b2ba94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e13-16c9-7629-9727-947e68b2ba94",
        "storage_key": "property/6737460151191752/019e1e13-16c9-7629-9727-947e68b2ba94.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://botanicgarden.okstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=226122513732717363&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-botanic-garden-at-oklahoma-state-university",
      "poi_latitude": "36.1168183",
      "poi_longitude": "-97.1005272",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-744-4643",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2672-700d-b6b0-7929505e5db2",
        "storage_key": "property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH_0n6QsKsYcRM8vBajpZIwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_214b98e5-084a-4a28-9545-c5fac70e95b7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Strickland Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "N Main St & W Hall of Fame Ave, N Main St, Stillwater, OK 74075, USA",
      "poi_short_description": "Public park featuring a playground, skateboarding area, and baseball field, plus picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-130b-74cd-9bb5-20964507e741.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-130b-74cd-9bb5-20964507e741",
        "storage_key": "property/6737460151191752/019e1e15-130b-74cd-9bb5-20964507e741.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://stillwater.org/page/home/community/parks-trails-open-spaces",
      "poi_directions_map_url": "https://maps.google.com/?cid=8466654949839271430&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "strickland-park",
      "poi_latitude": "36.1252927",
      "poi_longitude": "-97.0578575",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-747-8070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262e-738b-a8aa-405a2abe1808.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262e-738b-a8aa-405a2abe1808",
        "storage_key": "property/6737460151191752/019e1e13-262e-738b-a8aa-405a2abe1808.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHaqj1TYKsYcRBvb4kNGZf3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_28b277a5-af36-4fe4-9d3d-b664063697d5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Sanborn Lake Trails",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1303 W Arpt Rd, Stillwater, OK 74075, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-186d-72a8-a7ef-42e95614f0a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-186d-72a8-a7ef-42e95614f0a6",
        "storage_key": "property/6737460151191752/019e1e15-186d-72a8-a7ef-42e95614f0a6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stillwaterok.gov/839/Sanborn-Lake-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2889952884281325454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sanborn-lake-trails",
      "poi_latitude": "36.1550455",
      "poi_longitude": "-97.0771734",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-747-8070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2672-700d-b6b0-7929505e5db2",
        "storage_key": "property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ75JzoigJsYcRjjc0LdYsGyg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_81dae83f-36ff-450c-82ab-ecc48c03daa9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Babcock Soccer Fields",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Unnamed Road, Stillwater, OK 74074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-1d8d-70dc-80f1-cc7e74090a30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-1d8d-70dc-80f1-cc7e74090a30",
        "storage_key": "property/6737460151191752/019e1e15-1d8d-70dc-80f1-cc7e74090a30.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15266423560404509726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "babcock-soccer-fields",
      "poi_latitude": "36.1045687",
      "poi_longitude": "-97.0892511",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262e-738b-a8aa-405a2abe1808.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262e-738b-a8aa-405a2abe1808",
        "storage_key": "property/6737460151191752/019e1e13-262e-738b-a8aa-405a2abe1808.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJC2CUDnkKsYcRHqSQ3Fc73dM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_90cace90-bc07-4324-9812-c9ea61ad7172",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Lake McMurtry East Recreation Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "29180 Chisholm Curv, Stillwater, OK 74075, USA",
      "poi_short_description": "Park with 2 multi-use trails, 2 disc golf courses, and kayak rentals, plus camping sites and a bait shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-15b6-708b-94f8-132bbde41d2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-15b6-708b-94f8-132bbde41d2d",
        "storage_key": "property/6737460151191752/019e1e15-15b6-708b-94f8-132bbde41d2d.webp",
        "width": 1200,
        "height": 672
      },
      "poi_business_url": "http://www.lakemcmurtry.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3890368524893724061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-mcmurtry-east-recreation-area",
      "poi_latitude": "36.1831079",
      "poi_longitude": "-97.1746302",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-533-1831",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262e-738b-a8aa-405a2abe1808.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262e-738b-a8aa-405a2abe1808",
        "storage_key": "property/6737460151191752/019e1e13-262e-738b-a8aa-405a2abe1808.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_efLsH6msYcRnZ2ms49d_TU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e9f9416f-5571-41d0-9ee2-8f2efd3c8161",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Sunset Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "701 S Washington St, Stillwater, OK 74074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1675085331681261094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunset-park",
      "poi_latitude": "36.1141357",
      "poi_longitude": "-97.0691719",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262e-738b-a8aa-405a2abe1808.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262e-738b-a8aa-405a2abe1808",
        "storage_key": "property/6737460151191752/019e1e13-262e-738b-a8aa-405a2abe1808.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqKUIKsYcRJjZU8zsZPxc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_278bedc2-a327-491b-b686-d1de2316183f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Tower Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "215 S Walnut St, Stillwater, OK 74074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5550758061813049269&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tower-park",
      "poi_latitude": "36.1190456",
      "poi_longitude": "-97.077577",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262e-738b-a8aa-405a2abe1808.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262e-738b-a8aa-405a2abe1808",
        "storage_key": "property/6737460151191752/019e1e13-262e-738b-a8aa-405a2abe1808.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVsmwKsYcRtaeATAxBCE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ae6987af-2716-4ba1-8b16-b62726e0d814",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "OSU Department of Parking and Transportation Services",
      "poi_type": "Transportation & Transit",
      "poi_address": "1006 W Hall of Fame Ave, Stillwater, OK 74078, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://parking.okstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18176475629275199873&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "osu-department-of-parking-and-transportation-services",
      "poi_latitude": "36.1276387",
      "poi_longitude": "-97.0710276",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-744-6525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262b-73ff-9b6f-331284cf0c80",
        "storage_key": "property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJubA4lj0KsYcRgTl-H0jQP_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "academic_department"
    },
    {
      "id": "custom_fe53169f-2937-4f38-a616-410981632f7d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Stillwater Flight Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "2020 W Arpt Rd # 3, Stillwater, OK 74075, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-1c23-768c-a753-04a96d51ab60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-1c23-768c-a753-04a96d51ab60",
        "storage_key": "property/6737460151191752/019e1e15-1c23-768c-a753-04a96d51ab60.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.stillwaterflightcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2422148899144786770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stillwater-flight-center",
      "poi_latitude": "36.15763",
      "poi_longitude": "-97.0838726",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-624-5463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2672-700d-b6b0-7929505e5db2",
        "storage_key": "property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJseuwvdoJsYcRUuOgNpcznSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_98888596-193d-4083-a91f-f4857c823294",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "City of Stillwater, Stillwater Regional Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2020-1 W Arpt Rd, Stillwater, OK 74075, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-1d8a-74ad-8c99-10beee5b33aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e13-1d8a-74ad-8c99-10beee5b33aa",
        "storage_key": "property/6737460151191752/019e1e13-1d8a-74ad-8c99-10beee5b33aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://flystillwaterok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4360998016190650888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-stillwater-stillwater-regional-airport",
      "poi_latitude": "36.1578398",
      "poi_longitude": "-97.0838743",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-372-7881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-28d6-7616-8ea3-aab7f0f55a73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-28d6-7616-8ea3-aab7f0f55a73",
        "storage_key": "property/6737460151191752/019e1e13-28d6-7616-8ea3-aab7f0f55a73.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJi_vnf-cJsYcRCBo6FZdghTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_99b07887-f105-4b37-acfd-fe453df69632",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Student Union",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Student Union, 100 S Hester St, Stillwater, OK 74078, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-1cea-77a9-874d-ac1497384322.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-1cea-77a9-874d-ac1497384322",
        "storage_key": "property/6737460151191752/019e1e15-1cea-77a9-874d-ac1497384322.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://union.okstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7059686269323840708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "student-union",
      "poi_latitude": "36.1210998",
      "poi_longitude": "-97.0685679",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-744-5231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2672-700d-b6b0-7929505e5db2",
        "storage_key": "property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF2tEDD8KsYcRxAzAFEIL-WE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_42f557f1-95a9-4d26-9cd2-4d363df8b6c6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Oklahoma Water Resources Research Institute",
      "poi_type": "Major Employers & Offices",
      "poi_address": "501 Athletic Ave, Stillwater, OK 74078, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://water.okstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12354550176909412350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oklahoma-water-resources-research-institute",
      "poi_latitude": "36.123247",
      "poi_longitude": "-97.070978",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-744-9994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262b-73ff-9b6f-331284cf0c80",
        "storage_key": "property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv4EXJD4KsYcR_sdsvu0tdKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "research_institute"
    },
    {
      "id": "custom_19848236-885a-4921-8d84-f086477b8365",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "ASCO Aerospace USA LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3003 N Perkins Rd, Stillwater, OK 74075, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-2244-73bd-80d1-2e59ea868523.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-2244-73bd-80d1-2e59ea868523",
        "storage_key": "property/6737460151191752/019e1e15-2244-73bd-80d1-2e59ea868523.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.asco.be/contact/usa",
      "poi_directions_map_url": "https://maps.google.com/?cid=8991332429879890378&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asco-aerospace-usa-llc",
      "poi_latitude": "36.152657",
      "poi_longitude": "-97.0514987",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-533-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2672-700d-b6b0-7929505e5db2",
        "storage_key": "property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwlDKngJsYcRytFw9DShx3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_56bc5ddb-1d8e-467d-8fb5-e3c514e6bc47",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "National Standard",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3602 N Perkins Rd, Stillwater, OK 74075, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-2308-7521-9243-9acfa7754e3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-2308-7521-9243-9acfa7754e3e",
        "storage_key": "property/6737460151191752/019e1e15-2308-7521-9243-9acfa7754e3e.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.nationalstandard.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5782055732882504198&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-standard",
      "poi_latitude": "36.161286",
      "poi_longitude": "-97.0534822",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-777-1618",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2672-700d-b6b0-7929505e5db2",
        "storage_key": "property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3ebZPJ8JsYcRBvr47Q39PVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_8b693344-8edc-4d8c-bc61-50fb957cca65",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Stillwater Designs; Kicker World Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3100 N Husband St, Stillwater, OK 74075, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-23d7-7116-baea-b37d223ef8fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-23d7-7116-baea-b37d223ef8fb",
        "storage_key": "property/6737460151191752/019e1e15-23d7-7116-baea-b37d223ef8fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kicker.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7107374589054404671&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stillwater-designs-kicker-world-headquarters",
      "poi_latitude": "36.1539882",
      "poi_longitude": "-97.05837",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-256-5425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-2672-700d-b6b0-7929505e5db2",
        "storage_key": "property/6737460151191752/019e1e13-2672-700d-b6b0-7929505e5db2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe5XKIJsJsYcRP8g5Qoh3omI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_f302574f-94d8-4fa8-bccf-82796cdc4ded",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Meridian Technology Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1312 S Sangre Rd, Stillwater, OK 74074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-0489-707f-89c5-db1dd0d30220.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-0489-707f-89c5-db1dd0d30220",
        "storage_key": "property/6737460151191752/019e1e15-0489-707f-89c5-db1dd0d30220.webp",
        "width": 960,
        "height": 554
      },
      "poi_business_url": "http://www.meridiantech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13018562437666540088&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meridian-technology-center",
      "poi_latitude": "36.1068788",
      "poi_longitude": "-97.1070083",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-377-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262b-73ff-9b6f-331284cf0c80",
        "storage_key": "property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW6wHA5KgsYcROIpbz485q7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_5292d382-8b75-4e8a-9fbb-c2261d81ffa0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Northern Oklahoma College: Stillwater",
      "poi_type": "Major Employers & Offices",
      "poi_address": "615 N Monroe St, Stillwater, OK 74075, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-218f-753d-a952-106ea18c1d97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-218f-753d-a952-106ea18c1d97",
        "storage_key": "property/6737460151191752/019e1e15-218f-753d-a952-106ea18c1d97.webp",
        "width": 1200,
        "height": 630
      },
      "poi_business_url": "https://www.noc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13941069295911291453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northern-oklahoma-college-stillwater",
      "poi_latitude": "36.12923290000001",
      "poi_longitude": "-97.0716604",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 580-628-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-262b-73ff-9b6f-331284cf0c80",
        "storage_key": "property/6737460151191752/019e1e13-262b-73ff-9b6f-331284cf0c80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-Wt_ShYKsYcRPcrlY6mgeME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_94ee3089-debc-46c0-b006-a8e0281cb034",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "Payne County Courts Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "606 S Husband St Rooms 206 & 207, Stillwater, OK 74074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e15-2497-738c-80e9-b429576ac27e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-2497-738c-80e9-b429576ac27e",
        "storage_key": "property/6737460151191752/019e1e15-2497-738c-80e9-b429576ac27e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.paynecounty.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4436756311818615486&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "payne-county-courts-office",
      "poi_latitude": "36.1150015",
      "poi_longitude": "-97.0609629",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-372-4774",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-261d-75a9-add8-2d9e61518c9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-261d-75a9-add8-2d9e61518c9b",
        "storage_key": "property/6737460151191752/019e1e13-261d-75a9-add8-2d9e61518c9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF3BXAEYKsYcRvrrr0FuGkj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_32e61362-cfa3-4d9a-9e7b-afad8b5c1127",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "poi_name": "City of Stillwater, City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "723 S Lewis St, Stillwater, OK 74074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-1e01-75db-839e-d867fa742ed9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e13-1e01-75db-839e-d867fa742ed9",
        "storage_key": "property/6737460151191752/019e1e13-1e01-75db-839e-d867fa742ed9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://stillwaterok.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2649458078927673468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-stillwater-city-hall",
      "poi_latitude": "36.1139351",
      "poi_longitude": "-97.0568101",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-372-0025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e13-261d-75a9-add8-2d9e61518c9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e13-261d-75a9-add8-2d9e61518c9b",
        "storage_key": "property/6737460151191752/019e1e13-261d-75a9-add8-2d9e61518c9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyUEkzk4KsYcRfNjF2RXExCQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    }
  ],
  "office_hours": [
    {
      "id": "ec_27c37995ac4a84f6ecb92d4c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e4bdcca4ac79bf50cfd0df1e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_78016cede879b3259307f95a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6b9e600d62580d10ad10c2a1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ecd5175987e586ff8c072169",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f2853153c6fc0a073c4f17c9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_6375566b-e2ad-4372-b463-c5d2cecca1ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "rating": "5",
      "name": "Elena Masroor",
      "text": "Fifty-One has been a great place to live, and I have enjoyed my time here. The staff has always been reachable, kind, respectful, and helpful. The property also has great amenities, including a nice clubhouse, gym, and pool.\nI also appreciate that the community organizes events throughout the year and makes an effort to celebrate occasions like Valentine’s Day.\nThere have been a few minor issues, but they are small compared to the overall positive experience. For example, maintenance can sometimes be a little slow, and the gym bathroom does not always have paper towels.",
      "date": "2026-05-26",
      "title": "false"
    },
    {
      "id": "custom_bc30241c-2e60-48ff-834e-b780e4ab78ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "rating": "5",
      "name": "Saah Sicarr",
      "text": "I love living at The Brooks definitely my best living experience! Shoutout to the worker up front Audrel, he is very helpful in going above and beyond for me, and always helping me to get the propane grills working! I also wanted to say thank you to him because he actually convinced my friend to room with me here next year as well. The events you guys put on with that other organization on OSU campus at your pool really turned his head away from the other apartment he was looking at.",
      "date": "2026-05-08",
      "title": "false"
    },
    {
      "id": "custom_c03d0db1-1de2-4332-866b-a3f7f29a56e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "rating": "5",
      "name": "Charles Christopher",
      "text": "Audrel was extremely helpful and kind!",
      "date": "2026-05-08",
      "title": "false"
    },
    {
      "id": "custom_f67d93cd-96d7-47f1-b73e-f966317344de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "rating": "5",
      "name": "Savanna O'Brien",
      "text": "I have lived here for 2 years and can only say amazing things about Tradan! From the clubhouse, pool, apartments, everything is the best in town! Maintenance crew is amazing and always on top of things. If I wasn’t moving for work, I’d say here for much longer! If you’re looking for a safe, reliable, and beautiful apartment in town, this is the best. I’ve never had any issues in these two years, I can’t recommend this place enough!",
      "date": "2026-05-01",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_4d3541df-00f1-421c-8ddc-b40ab9bb9651",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019e1e12-df76-738a-8a14-f8717c3ff5aa.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1e12-df76-738a-8a14-f8717c3ff5aa",
        "storage_key": "property/6737460151191752/019e1e12-df76-738a-8a14-f8717c3ff5aa.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Entrance",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=667ee00d2480857a5e51fd37"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993e6f-112c-76dc-8e60-f9100a2ea818",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-5iftyone-at-tradan-heights-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752"
    },
    {
      "lead_collector_id": "019a185e-0cf4-746b-ae43-4182a96717cb",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-fiftyone-at-tradan-heights-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-stillwater",
      "search_query": "apartments with in-unit laundry Stillwater OK",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Stillwater",
      "h2_subtitle": "Discover the convenience of apartments with in-unit laundry in Stillwater. Enjoy modern living at 5iftyone Tradan Heights in Oklahoma East Area.",
      "page_copy": "Discover unparalleled convenience at 5iftyone Tradan Heights, where we offer apartments with in-unit laundry in Stillwater, OK. Our community provides a modern lifestyle with the luxury of doing laundry without leaving the comfort of your own home. Choose from our spacious one or two-bedroom floor plans, designed with functionality and style in mind. \n\nLocated in Oklahoma East Area, our community features outstanding amenities, including a dog park, gas grills, and a fitness center open 24 hours a day. Whether you're taking a dip in the sparkling pool or enjoying the pet-friendly atmosphere, 5iftyone Tradan Heights is the perfect place to call home. Schedule a tour today and discover the benefits of having in-unit laundry at your fingertips!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019d076e-01c8-73f9-8715-71958dc22c29.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with plush seating, fireplace, and entertainment.",
        "public_id": "019d076e-01c8-73f9-8715-71958dc22c29",
        "storage_key": "property/6737460151191752/019d076e-01c8-73f9-8715-71958dc22c29.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Stillwater, OK",
      "seo_description": "Find apartments with in-unit laundry in Stillwater, OK at 5iftyone Tradan Heights. Enjoy modern living with great amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-dog-park-payne-county",
      "search_query": "pet-friendly apartments with dog park Payne County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Payne County",
      "h2_subtitle": "Explore pet-friendly apartments with a dog park in Payne County. Discover the welcoming environment of 5iftyone Tradan Heights.",
      "page_copy": "Welcome to 5iftyone Tradan Heights, where we offer pet-friendly apartments in Payne County for residents with furry companions. Our community not only welcomes pets with open arms but also features a dedicated dog park, allowing your pets to run and play freely. With our range of one and two-bedroom floor plans, you're sure to find a home that suits both you and your four-legged friends.\n\nSet in the heart of the Oklahoma East Area, 5iftyone Tradan Heights combines comfort with convenience. Our amenities, such as gas grills, a sparkling pool, and a 24-hour fitness center, cater to a vibrant lifestyle. Enjoy the community while ensuring that your pets have ample space and freedom. Visit us today and discover why our pet-friendly apartments are the perfect choice in Payne County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019d076e-01c8-73f9-8715-71958dc22c29.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with plush seating, fireplace, and entertainment.",
        "public_id": "019d076e-01c8-73f9-8715-71958dc22c29",
        "storage_key": "property/6737460151191752/019d076e-01c8-73f9-8715-71958dc22c29.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Payne County",
      "seo_description": "Discover pet-friendly living in Payne County with a dog park at 5iftyone Tradan Heights. Perfect for you and your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "page_item_url": "luxury-apartments-pool-oklahoma-east-area",
      "search_query": "luxury apartments with pool in Oklahoma East Area",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Oklahoma East",
      "h2_subtitle": "Experience luxury living in Oklahoma East Area with stylish apartments featuring a sparkling pool. Discover 5iftyone Tradan Heights today.",
      "page_copy": "At 5iftyone Tradan Heights, indulge in the luxury apartments with a pool located in the Oklahoma East Area. Our community offers expansive living spaces in one and two-bedroom layouts, designed with elegance and sophistication. The centerpiece of our amenities is the stunning sparkling pool, perfect for relaxation or socializing with neighbors.\n\nNestled in Stillwater, OK, our property also boasts premier features such as a 24-hour fitness center, property manager on-site, and ample parking, all designed to enhance your living experience. Whether you're lounging by the pool or hosting a weekend barbeque with our gas grills, life at 5iftyone Tradan Heights is both luxurious and convenient. Schedule your visit today and see what makes our community a top choice for luxury living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019d076e-01c8-73f9-8715-71958dc22c29.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with plush seating, fireplace, and entertainment.",
        "public_id": "019d076e-01c8-73f9-8715-71958dc22c29",
        "storage_key": "property/6737460151191752/019d076e-01c8-73f9-8715-71958dc22c29.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Oklahoma East",
      "seo_description": "Discover luxury apartments with a pool in the Oklahoma East Area at 5iftyone Tradan Heights. Experience top-tier amenities and luxury living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-stillwater-74074",
      "search_query": "air conditioned apartments in Stillwater 74074",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Stillwater",
      "h2_subtitle": "Find comfort in air-conditioned apartments in Stillwater, 74074. Discover the serene lifestyle at 5iftyone Tradan Heights today.",
      "page_copy": "Enjoy a comfortable living experience at 5iftyone Tradan Heights, offering air-conditioned apartments in the heart of Stillwater, 74074. Our community provides an inviting sanctuary where you can escape the heat and relax in a perfectly climate-controlled environment. Choose from our spacious floor plans, featuring options of one and two bedrooms designed to meet your modern lifestyle needs.\n\nLocated in the charming Oklahoma East Area, 5iftyone Tradan Heights impresses with amenities like a sparkling pool, gas fire pit, and a 24-hour fitness center. Our vibrant community ensures that you have everything you need right at your doorstep, while the air-conditioned interiors provide a cool refuge during hot Oklahoma days. Discover our tranquil, well-equipped apartments and schedule a visit to make 5iftyone Tradan Heights your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019d076e-01c8-73f9-8715-71958dc22c29.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with plush seating, fireplace, and entertainment.",
        "public_id": "019d076e-01c8-73f9-8715-71958dc22c29",
        "storage_key": "property/6737460151191752/019d076e-01c8-73f9-8715-71958dc22c29.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Stillwater 74074",
      "seo_description": "Stay cool in Stillwater, 74074 with air-conditioned apartments at 5iftyone Tradan Heights. Enjoy comfort and convenience in our vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "page_item_url": "apartments-with-dishwasher-stillwater-ok",
      "search_query": "apartments with dishwasher in Stillwater OK",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Stillwater",
      "h2_subtitle": "Discover convenience in Stillwater, OK with apartments featuring dishwashers. Experience modern living at 5iftyone Tradan Heights.",
      "page_copy": "Experience the ultimate in convenience at 5iftyone Tradan Heights, offering apartments with dishwashers in Stillwater, OK. Our community is designed to make life easier, providing modern amenities that include built-in dishwashers in each unit. Choose from our carefully planned one and two-bedroom apartments, all tailored for comfort and efficiency.\n\nNestled in the Oklahoma East Area, our welcoming community features a host of amenities such as a sparkling pool, gas fire pit, and a fitness center that's open around the clock. At 5iftyone Tradan Heights, not only do you benefit from contemporary kitchen appliances like dishwashers, but you also have access to a full range of lifestyle enhancements that make everyday living a pleasure. Visit us today to find the perfect home that meets all your needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019d076e-01c8-73f9-8715-71958dc22c29.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with plush seating, fireplace, and entertainment.",
        "public_id": "019d076e-01c8-73f9-8715-71958dc22c29",
        "storage_key": "property/6737460151191752/019d076e-01c8-73f9-8715-71958dc22c29.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in Stillwater OK",
      "seo_description": "Find convenient living in Stillwater, OK with apartments featuring dishwashers at 5iftyone Tradan Heights. Enjoy modern amenities and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-stillwater-ok",
      "search_query": "1 bedroom apartments in Stillwater OK",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Stillwater, OK",
      "h2_subtitle": "Explore charming 1 bedroom apartments in Stillwater, OK at 5iftyone Tradan Heights. Enjoy luxury and comfort in a vibrant community.",
      "page_copy": "Discover the perfect blend of comfort and style with our 1 bedroom apartments in Stillwater, OK at 5iftyone Tradan Heights. Each apartment offers a spacious layout that blends modern design with functionality, perfect for individuals seeking a cozy yet sophisticated living space.\n\nLocated in the coveted Oklahoma East Area, our community provides exceptional amenities like a sparkling pool, gas grills, and a 24-hour fitness center, all aimed at enriching your lifestyle. With ample parking and on-site management, living at 5iftyone Tradan Heights ensures convenience and satisfaction. Book a tour today and see why our 1 bedroom apartments stand out as a top choice in Stillwater.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019d076e-01c8-73f9-8715-71958dc22c29.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with plush seating, fireplace, and entertainment.",
        "public_id": "019d076e-01c8-73f9-8715-71958dc22c29",
        "storage_key": "property/6737460151191752/019d076e-01c8-73f9-8715-71958dc22c29.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Stillwater, OK",
      "seo_description": "Find your ideal 1 bedroom apartment in Stillwater, OK at 5iftyone Tradan Heights. Experience modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191752",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-payne-county",
      "search_query": "2 bedroom apartments in Payne County",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Payne County",
      "h2_subtitle": "Find spacious 2 bedroom apartments in Payne County at 5iftyone Tradan Heights. Enjoy luxury and modern amenities in our community.",
      "page_copy": "Experience exceptional living at 5iftyone Tradan Heights, offering 2 bedroom apartments in Payne County. Our thoughtfully designed floor plans provide ample space and comfort, making them ideal for those seeking a balanced lifestyle between work and relaxation.\n\nNestled in the pleasant environment of the Oklahoma East Area in Stillwater, our community grants residents access to top-notch amenities like a gas fire pit, dog park, and sparkling pools. Additionally, our property features a 24-hour fitness center and on-site management, ensuring that your living experience is convenient and carefree. Live a life of convenience and style in our 2 bedroom apartments at 5iftyone Tradan Heights.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191752/019d076e-01c8-73f9-8715-71958dc22c29.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with plush seating, fireplace, and entertainment.",
        "public_id": "019d076e-01c8-73f9-8715-71958dc22c29",
        "storage_key": "property/6737460151191752/019d076e-01c8-73f9-8715-71958dc22c29.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Payne County",
      "seo_description": "Explore 2 bedroom apartments in Payne County at 5iftyone Tradan Heights. Enjoy spacious living with modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3367"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483351"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5026472"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TZ5FVPHB"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_zu_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=zu"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "405-643-8890"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "405-689-9574"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "405-451-1210"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "405-925-0920"
    },
    {
      "ID": "custom_knock_zu_title",
      "type": "STRING",
      "value": "Zumper"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "405-489-4260"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "405-645-7819"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "405-829-6910"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "405-645-5596"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "405-867-6375"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "405-454-8017"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_knock_zu_number",
      "type": "STRING",
      "value": "405-246-9953"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "405-873-8112"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "405-351-6798"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "405-477-8773"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "405-363-6531"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "405-363-4338"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "405-583-7534"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "405-860-6650"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "405-956-2130"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321121429"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "405-643-6243"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "405-389-8290"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "041c3a11ee9135f3"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "405-393-5400"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "405-956-2456"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "405-643-4625"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "405-963-4398"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "405-993-4305"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "405-452-8201"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "405-926-8158"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.tradanheights.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151191752/019e60c7-cd07-73f6-b8cf-603a8dba7200.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "405-299-0302"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "405-454-8017"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3367",
  "custom_repli_id": "5028483351",
  "custom_realpage_id": "5026472",
  "custom_knock_a_link": "https://www.tradanheights.com?utm_knock=a",
  "custom_knock_g_link": "https://www.tradanheights.com?utm_knock=g",
  "custom_knock_r_link": "https://www.tradanheights.com?utm_knock=r",
  "custom_knock_w_link": "https://www.tradanheights.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-TZ5FVPHB",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.tradanheights.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.tradanheights.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.tradanheights.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.tradanheights.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.tradanheights.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.tradanheights.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_zu_link": "https://www.tradanheights.com?utm_knock=zu",
  "custom_knock_a_number": "405-643-8890",
  "custom_knock_ads_link": "https://www.tradanheights.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.tradanheights.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "405-689-9574",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.tradanheights.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.tradanheights.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.tradanheights.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.tradanheights.com?utm_knock=psa",
  "custom_knock_r_number": "405-451-1210",
  "custom_knock_w_number": "405-925-0920",
  "custom_knock_zu_title": "Zumper",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "405-489-4260",
  "custom_knock_amap_link": "https://www.tradanheights.com?utm_knock=amap",
  "custom_knock_ar_number": "405-645-7819",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "405-829-6910",
  "custom_knock_fb_number": "405-645-5596",
  "custom_knock_fl_number": "405-867-6375",
  "custom_knock_gp_number": "405-454-8017",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.tradanheights.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_knock_zu_number": "405-246-9953",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "405-873-8112",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.tradanheights.com?utm_knock=bcard",
  "custom_knock_bnr_number": "405-351-6798",
  "custom_knock_cfres_link": "https://www.tradanheights.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "405-477-8773",
  "custom_knock_lgp_number": "405-363-6531",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.tradanheights.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "405-363-4338",
  "custom_knock_psa_number": "405-583-7534",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "405-860-6650",
  "custom_knock_bandit_link": "https://www.tradanheights.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.tradanheights.com?utm_knock=flyers",
  "custom_knock_osoc_number": "405-956-2130",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321121429",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "405-643-6243",
  "custom_knock_cfres_number": "405-389-8290",
  "custom_knock_chatgpt_link": "https://www.tradanheights.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "041c3a11ee9135f3",
  "custom_knock_dirmail_link": "https://www.tradanheights.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "405-393-5400",
  "custom_knock_propbro_link": "https://www.tradanheights.com?utm_knock=propbro",
  "custom_knock_bandit_number": "405-956-2456",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "405-643-4625",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.tradanheights.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "405-963-4398",
  "custom_knock_dirmail_number": "405-993-4305",
  "custom_knock_propbro_number": "405-452-8201",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "405-926-8158",
  "custom_knock_maintenance_link": "https://www.tradanheights.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151191752/019e60c7-cd07-73f6-b8cf-603a8dba7200.mp4",
  "custom_knock_maintenance_number": "405-299-0302",
  "custom_ppc_tracking_phone_number": "405-454-8017"
};

export const generatedAt = '2026-10-07T17:15:11.285Z';
